import { Quiz } from '@/types/quiz';

export const quizAll: Quiz[] = [
  {
    quizId: '1',
    question: 'ヒカルの碁を監修しているプロ棋士は？',
    options: [
      { optionId: '0', text: '梅澤由香里' },
      { optionId: '1', text: '榊原史子' },
      { optionId: '2', text: '中澤彩子' },
      { optionId: '3', text: '岡田結美子' },
      { optionId: '4', text: '知念かおり' },
    ],
  },
  {
    quizId: '2',
    question: 'ヒカルの碁の話数カウントは？',
    options: [
      { optionId: '0', text: '局' },
      { optionId: '1', text: '手' },
      { optionId: '2', text: '話' },
      { optionId: '3', text: '打' },
      { optionId: '4', text: '目' },
    ],
  },
  {
    quizId: '3',
    question: 'ヒカルの碁連載開始時、初登場時のヒカルがいた場所は？',
    options: [
      { optionId: '0', text: '蔵' },
      { optionId: '1', text: '病院' },
      { optionId: '2', text: '学校の教室' },
      { optionId: '3', text: '囲碁教室' },
      { optionId: '4', text: '自宅' },
    ],
  },
  {
    quizId: '4',
    question:
      '小学生編より問題です。\nヒカルが蔵の中からお宝を探していたのははこづかいを止められたからですが、こづかいを止められた理由は？',
    options: [
      { optionId: '0', text: '社会のテストで8点しかとれなかったから' },
      { optionId: '1', text: '家の手伝いをしないから' },
      { optionId: '2', text: '宿題をせずに遊んでいたから' },
      { optionId: '3', text: '夜更かし等、生活が乱れているから' },
      { optionId: '4', text: 'ムダつかいが目立つから' },
    ],
  },
  {
    quizId: '5',
    question: '初登場時の進藤ヒカルのクラスは？',
    options: [
      { optionId: '0', text: '44713' },
      { optionId: '1', text: '44714' },
      { optionId: '2', text: '44715' },
      { optionId: '3', text: '6-A' },
      { optionId: '4', text: '6-B' },
    ],
  },
  {
    quizId: '6',
    question:
      '平安の都で囲碁指南を務めていた佐為、囲碁指南役を決める対局で相手がしたズルは？',
    options: [
      { optionId: '0', text: '碁笥の石をアゲハマにした' },
      { optionId: '1', text: '整地をごまかした' },
      { optionId: '2', text: '石を動かした' },
      { optionId: '3', text: '三味線を弾いた' },
      { optionId: '4', text: '石を打ち直した' },
    ],
  },
  {
    quizId: '7',
    question:
      '囲碁指南役を決める対局で負けた佐為は、その後どのような人生を送った？',
    options: [
      { optionId: '0', text: '2日後に入水' },
      { optionId: '1', text: '翌日に服毒' },
      { optionId: '2', text: '翌日から断食' },
      { optionId: '3', text: '2日後に服毒' },
      { optionId: '4', text: '翌日に入水' },
    ],
  },
  {
    quizId: '8',
    question: '本因坊秀策がはやり病にかかり亡くなった時の年齢は？',
    options: [
      { optionId: '0', text: '34歳' },
      { optionId: '1', text: '26歳' },
      { optionId: '2', text: '30歳' },
      { optionId: '3', text: '38歳' },
      { optionId: '4', text: '42歳' },
    ],
  },
  {
    quizId: '9',
    question:
      '小学生編より問題です。\n佐為は自動販売機を初めて見た時に、ヒカルが飲み物を買った時の音から何だと尋ねた？',
    options: [
      { optionId: '0', text: 'ゴロゴロガラン' },
      { optionId: '1', text: 'ガタンゴトッ' },
      { optionId: '2', text: 'ガラガラゴトン' },
      { optionId: '3', text: 'ガコッゴトン' },
      { optionId: '4', text: 'ダトッゴトン' },
    ],
  },
  {
    quizId: '10',
    question: '佐為の宿っていた碁盤にある血のシミは誰のもの？',
    options: [
      { optionId: '0', text: '本因坊秀策' },
      { optionId: '1', text: '藤原佐為' },
      { optionId: '2', text: '囲碁指南役' },
      { optionId: '3', text: '進藤ヒカル' },
      { optionId: '4', text: '不明' },
    ],
  },
  {
    quizId: '11',
    question: '藤原佐為が碁を打てないことによる悲しみでヒカルが吐いた回数は？',
    options: [
      { optionId: '0', text: '2回' },
      { optionId: '1', text: '1回' },
      { optionId: '2', text: '3回' },
      { optionId: '3', text: '4回' },
      { optionId: '4', text: '5回' },
    ],
  },
  {
    quizId: '12',
    question: 'ヒカルのじいちゃんの名前は？',
    options: [
      { optionId: '0', text: '進藤平八' },
      { optionId: '1', text: '進藤栄吉' },
      { optionId: '2', text: '進藤茂之' },
      { optionId: '3', text: '進藤和夫' },
      { optionId: '4', text: '進藤清' },
    ],
  },
  {
    quizId: '13',
    question:
      'あかりが囲碁教室に来始めてから優しくなった、初登場時には囲碁教室で弱い者イジメをしていた人は？',
    options: [
      { optionId: '0', text: '阿古田' },
      { optionId: '1', text: '森' },
      { optionId: '2', text: '坂巻' },
      { optionId: '3', text: '北島' },
      { optionId: '4', text: '市河' },
    ],
  },
  {
    quizId: '14',
    question: '一巻時点の塔矢名人は何冠？',
    options: [
      { optionId: '0', text: '3冠' },
      { optionId: '1', text: '2冠' },
      { optionId: '2', text: '4冠' },
      { optionId: '3', text: '5冠' },
      { optionId: '4', text: '6冠' },
    ],
  },
  {
    quizId: '15',
    question:
      '小学生編より問題です。\n佐為が初めてテレビを目撃したときに映っていた塔矢行洋がしていた対局は？',
    options: [
      { optionId: '0', text: '天元戦' },
      { optionId: '1', text: '棋聖戦' },
      { optionId: '2', text: '碁聖戦' },
      { optionId: '3', text: '名人戦' },
      { optionId: '4', text: '十段戦' },
    ],
  },
  {
    quizId: '16',
    question: '塔矢アキラがよく通っている、塔矢名人が経営する碁会所は？',
    options: [
      { optionId: '0', text: '囲碁サロン' },
      { optionId: '1', text: '天元' },
      { optionId: '2', text: '道玄坂' },
      { optionId: '3', text: '柳' },
      { optionId: '4', text: '石心' },
    ],
  },
  {
    quizId: '17',
    question: '囲碁サロンの席料、子ども料金はいくら？',
    options: [
      { optionId: '0', text: '五百円' },
      { optionId: '1', text: '無料' },
      { optionId: '2', text: '三百円' },
      { optionId: '3', text: '八百円' },
      { optionId: '4', text: '千円' },
    ],
  },
  {
    quizId: '18',
    question:
      '小学生編より問題です。\n佐為の力でヒカルが初めて塔矢アキラと対局したときの、コミ無しでの結果は？',
    options: [
      { optionId: '0', text: '黒の2目勝ち' },
      { optionId: '1', text: '白の3目勝ち' },
      { optionId: '2', text: '白の2目勝ち' },
      { optionId: '3', text: '白の5目勝ち' },
      { optionId: '4', text: '黒の5目勝ち' },
    ],
  },
  {
    quizId: '19',
    question:
      '小学生編より問題です。\n社会のテストで佐為の力を借りた代わりに、ヒカルが訪れた囲碁大会は？',
    options: [
      { optionId: '0', text: '第19回 全国こども囲碁大会' },
      { optionId: '1', text: '第14期 NCC杯' },
      { optionId: '2', text: '西湘祭・囲碁フェスタ' },
      { optionId: '3', text: '第16回 こどもチーム対抗戦' },
      { optionId: '4', text: '第12回 山猫急便杯' },
    ],
  },
  {
    quizId: '20',
    question:
      '小学生編より問題です。\n全国こども囲碁大会でついヒカルが口を出してしまったのは？',
    options: [
      { optionId: '0', text: '1の二が急所' },
      { optionId: '1', text: '2の三が急所' },
      { optionId: '2', text: '3の二が急所' },
      { optionId: '3', text: '1の三が急所' },
      { optionId: '4', text: '2の一が急所' },
    ],
  },
  {
    quizId: '21',
    question:
      '小学生編より問題です。\n全国こども囲碁大会で口を出してしまったヒカルを止めたのは？',
    options: [
      { optionId: '0', text: '森' },
      { optionId: '1', text: '緒方' },
      { optionId: '2', text: '柿本' },
      { optionId: '3', text: '坂巻' },
      { optionId: '4', text: '池下' },
    ],
  },
  {
    quizId: '22',
    question: '囲碁サロンの席亭は？',
    options: [
      { optionId: '0', text: '市河晴美' },
      { optionId: '1', text: '市河佳奈子' },
      { optionId: '2', text: '市河香菜' },
      { optionId: '3', text: '市河遥' },
      { optionId: '4', text: '市河陽子' },
    ],
  },
  {
    quizId: '23',
    question:
      '小学生編より問題です。\n塔矢アキラの言によると八冠での賞金総額はどのくらい？',
    options: [
      { optionId: '0', text: '一億二千万くらい' },
      { optionId: '1', text: '二億五千万くらい' },
      { optionId: '2', text: '三億八千万くらい' },
      { optionId: '3', text: '五億くらい' },
      { optionId: '4', text: '十億くらい' },
    ],
  },
  {
    quizId: '24',
    question:
      '小学生編より問題です。\n塔矢アキラが誇りしていた塔矢行洋に言われた二つの才能は？',
    options: [
      {
        optionId: '0',
        text: '誰よりも努力を惜しまない才能、限りなく囲碁を愛する才能',
      },
      {
        optionId: '1',
        text: '誰よりも努力を惜しまない才能、何があっても諦めない才能',
      },
      {
        optionId: '2',
        text: '誰よりも努力を惜しまない才能、前だけ見続ける才能',
      },
      {
        optionId: '3',
        text: '心から囲碁を楽しむ才能、限りなく囲碁を愛する才能',
      },
      { optionId: '4', text: '前だけ見続ける才能、何があっても諦めない才能' },
    ],
  },
  {
    quizId: '25',
    question:
      '小学生編より問題です。\nヒカルを葉瀬中創立祭に誘ったあかりが持っていたのは何の券？',
    options: [
      { optionId: '0', text: 'たこ焼き' },
      { optionId: '1', text: 'お好み焼き' },
      { optionId: '2', text: 'クレープ' },
      { optionId: '3', text: '焼き鳥' },
      { optionId: '4', text: '焼きそば' },
    ],
  },
  {
    quizId: '26',
    question:
      '小学生編より問題です。\nあかりに誘われて行った葉瀬中創立祭でヒカルが自力で解いた詰碁の景品は？',
    options: [
      { optionId: '0', text: 'ポケットティッシュ' },
      { optionId: '1', text: '缶ジュース' },
      { optionId: '2', text: '塔矢名人選詰碁集' },
      { optionId: '3', text: '商品券100円分' },
      { optionId: '4', text: '10円ガム' },
    ],
  },
  {
    quizId: '27',
    question:
      '小学生編より問題です。\n葉瀬中創立祭でのヒカルと加賀の対局、ヒカルの初手は？',
    options: [
      { optionId: '0', text: '17の四' },
      { optionId: '1', text: '7の十' },
      { optionId: '2', text: '16の四' },
      { optionId: '3', text: '3の四' },
      { optionId: '4', text: '3の三' },
    ],
  },
  {
    quizId: '28',
    question: '小学生編より問題です。\n葉瀬中創立祭にあかりは誰と行った？',
    options: [
      { optionId: '0', text: 'サヤカ達' },
      { optionId: '1', text: 'ヒカル' },
      { optionId: '2', text: 'カオリ達' },
      { optionId: '3', text: 'エリ達' },
      { optionId: '4', text: 'キョウコ達' },
    ],
  },
  {
    quizId: '29',
    question:
      '小学生編より問題です。\n小六のヒカルが葉瀬中の三将として参加した大会は？',
    options: [
      { optionId: '0', text: '第三回 北区中学冬期囲碁大会' },
      { optionId: '1', text: '第二回 北区中学冬期囲碁大会' },
      { optionId: '2', text: '第二回 南区中学冬期囲碁大会' },
      { optionId: '3', text: '第三回 北区中学夏期囲碁大会' },
      { optionId: '4', text: '第三回 南区中学冬期囲碁大会' },
    ],
  },
  {
    quizId: '30',
    question:
      '小学生編より問題です。\n中学生の大会に出ていたヒカルのことを小学生だと知っていた、はす向かいに住んでいる海王中の生徒は？',
    options: [
      { optionId: '0', text: '高田' },
      { optionId: '1', text: '青木' },
      { optionId: '2', text: '久野' },
      { optionId: '3', text: '池下' },
      { optionId: '4', text: '森山' },
    ],
  },
  {
    quizId: '31',
    question: 'ストーリーキング応募時、ヒカルの碁は何というタイトルだった？',
    options: [
      { optionId: '0', text: '九つの星' },
      { optionId: '1', text: '幽霊棋士' },
      { optionId: '2', text: '神様の囲碁' },
      { optionId: '3', text: '永久の宙' },
      { optionId: '4', text: 'ヒカルの奏' },
    ],
  },
  {
    quizId: '32',
    question:
      '小学生編より問題です。\nヒカル、筒井、加賀の3人で出場した団体戦の一回戦、二回戦の対局中に筒井が持っていた本は？',
    options: [
      { optionId: '0', text: '囲碁上達シリーズ 定石の打ち方 100' },
      { optionId: '1', text: '上達講座シリーズ 早わかり 布石大辞典' },
      { optionId: '2', text: '強くなる基本手筋 100' },
      { optionId: '3', text: '基本がわかる囲碁トレーニング' },
      { optionId: '4', text: '基礎からわかる定石の生かし方' },
    ],
  },
  {
    quizId: '33',
    question:
      '小学生編より問題です。\nヒカル、筒井、加賀の3人で出場した団体戦、葉瀬中の一回戦の対戦校は？',
    options: [
      { optionId: '0', text: '川萩中' },
      { optionId: '1', text: '浜地中' },
      { optionId: '2', text: '阿由中' },
      { optionId: '3', text: '岩名中' },
      { optionId: '4', text: '海王中' },
    ],
  },
  {
    quizId: '34',
    question:
      '小学生編より問題です。\nヒカル、筒井、加賀の3人で出場した団体戦、一回戦の加賀の相手は？',
    options: [
      { optionId: '0', text: '池下' },
      { optionId: '1', text: '森山' },
      { optionId: '2', text: '宇野' },
      { optionId: '3', text: '久野' },
      { optionId: '4', text: '高田' },
    ],
  },
  {
    quizId: '35',
    question:
      '小学生編より問題です。\nヒカル、筒井、加賀の3人で出場した大会で、男子一回戦で敗北した高校は？',
    options: [
      { optionId: '0', text: '岩名中' },
      { optionId: '1', text: '葉瀬中' },
      { optionId: '2', text: '佐和良中' },
      { optionId: '3', text: '田井中' },
      { optionId: '4', text: '海王中' },
    ],
  },
  {
    quizId: '36',
    question: '海王中の囲碁部の先生は？',
    options: [
      { optionId: '0', text: '尹先生' },
      { optionId: '1', text: '柳先生' },
      { optionId: '2', text: '朴先生' },
      { optionId: '3', text: '金先生' },
      { optionId: '4', text: '崔先生' },
    ],
  },
  {
    quizId: '37',
    question:
      '葉瀬中囲碁部編より問題です。\n使っていない碁盤と碁石を囲碁部にくれた、葉瀬中の理科の先生は？',
    options: [
      { optionId: '0', text: 'タマ子先生' },
      { optionId: '1', text: 'レイ子先生' },
      { optionId: '2', text: 'ハル子先生' },
      { optionId: '3', text: 'アヤ子先生' },
      { optionId: '4', text: 'ミワ子先生' },
    ],
  },
  {
    quizId: '38',
    question: '葉瀬中囲碁部が使用している部屋は？',
    options: [
      { optionId: '0', text: '理科室' },
      { optionId: '1', text: '理科準備室' },
      { optionId: '2', text: '囲碁部室' },
      { optionId: '3', text: '音楽室' },
      { optionId: '4', text: '図書室' },
    ],
  },
  {
    quizId: '39',
    question:
      '葉瀬中囲碁部編より問題です。\n塔矢アキラが入ったときの海王中囲碁部の新入部員数は？',
    options: [
      { optionId: '0', text: '17名' },
      { optionId: '1', text: '8名' },
      { optionId: '2', text: '12名' },
      { optionId: '3', text: '15名' },
      { optionId: '4', text: '21名' },
    ],
  },
  {
    quizId: '40',
    question:
      '葉瀬中囲碁部編より問題です。\nヒカルが書店で塔矢名人選詰碁集と一緒に購入した3冊の本の合計金額は？',
    options: [
      { optionId: '0', text: '千六百三十円' },
      { optionId: '1', text: '千九百五十円' },
      { optionId: '2', text: '二千百円' },
      { optionId: '3', text: '二千七百八十円' },
      { optionId: '4', text: '三千二百七十円' },
    ],
  },
  {
    quizId: '41',
    question:
      '葉瀬中囲碁部編より問題です。\n塔矢アキラにマネ碁を仕掛けたのは？',
    options: [
      { optionId: '0', text: '奥村' },
      { optionId: '1', text: '伊藤' },
      { optionId: '2', text: '小島' },
      { optionId: '3', text: '青木' },
      { optionId: '4', text: '久野' },
    ],
  },
  {
    quizId: '42',
    question:
      '葉瀬中囲碁部編より問題です。\n目隠し碁を塔矢アキラと打った、伊藤の第一手は？',
    options: [
      { optionId: '0', text: '16の四' },
      { optionId: '1', text: '17の四' },
      { optionId: '2', text: '7の十' },
      { optionId: '3', text: '3の四' },
      { optionId: '4', text: '3の三' },
    ],
  },
  {
    quizId: '43',
    question: '葉瀬中囲碁部編より問題です。\n三谷の中学一年の時のクラスは？',
    options: [
      { optionId: '0', text: '3組' },
      { optionId: '1', text: '1組' },
      { optionId: '2', text: '2組' },
      { optionId: '3', text: 'A組' },
      { optionId: '4', text: 'B組' },
    ],
  },
  {
    quizId: '44',
    question: '葉瀬中囲碁部編より問題です。\nヒカルが三谷と会った碁会所は？',
    options: [
      { optionId: '0', text: '囲碁さろん' },
      { optionId: '1', text: '天元' },
      { optionId: '2', text: '道玄坂' },
      { optionId: '3', text: '囲碁クラス' },
      { optionId: '4', text: '石心' },
    ],
  },
  {
    quizId: '45',
    question: '囲碁さろんのこども料金は？',
    options: [
      { optionId: '0', text: '500円' },
      { optionId: '1', text: '無料' },
      { optionId: '2', text: '300円' },
      { optionId: '3', text: '800円' },
      { optionId: '4', text: '1000円' },
    ],
  },
  {
    quizId: '46',
    question: '囲碁さろんの席亭は？',
    options: [
      { optionId: '0', text: '修さん' },
      { optionId: '1', text: '竹さん' },
      { optionId: '2', text: '重さん' },
      { optionId: '3', text: '宮さん' },
      { optionId: '4', text: '二郎さん' },
    ],
  },
  {
    quizId: '47',
    question: '“勝ったらいくら”の賭け碁のことを何という？',
    options: [
      { optionId: '0', text: '番碁' },
      { optionId: '1', text: '目碁' },
      { optionId: '2', text: '調碁' },
      { optionId: '3', text: '定碁' },
      { optionId: '4', text: '締碁' },
    ],
  },
  {
    quizId: '48',
    question: '葉瀬中囲碁部編より問題です。\n三谷と一万円の賭け碁をしたのは？',
    options: [
      { optionId: '0', text: 'ダケさん' },
      { optionId: '1', text: 'シュウさん' },
      { optionId: '2', text: 'シゲさん' },
      { optionId: '3', text: 'ミヤさん' },
      { optionId: '4', text: 'ジロさん' },
    ],
  },
  {
    quizId: '49',
    question:
      '葉瀬中囲碁部編より問題です。\n第四回 北区中学夏期囲碁大会で海王中の副将を務めていたのは？',
    options: [
      { optionId: '0', text: '久野' },
      { optionId: '1', text: '岸本' },
      { optionId: '2', text: '青木' },
      { optionId: '3', text: '奥村' },
      { optionId: '4', text: '日高' },
    ],
  },
  {
    quizId: '50',
    question: '葉瀬中囲碁部編より問題です。\n塔矢行洋の持つ碁聖への挑戦者は？',
    options: [
      { optionId: '0', text: '桑原' },
      { optionId: '1', text: '一柳' },
      { optionId: '2', text: '座間' },
      { optionId: '3', text: '緒方' },
      { optionId: '4', text: '芹澤' },
    ],
  },
  {
    quizId: '51',
    question:
      '葉瀬中囲碁部編より問題です。\n第四回 北区中学夏期囲碁大会で葉瀬中の一回戦の対戦校は？',
    options: [
      { optionId: '0', text: '岩名中' },
      { optionId: '1', text: '浜地中' },
      { optionId: '2', text: '阿由中' },
      { optionId: '3', text: '川萩中' },
      { optionId: '4', text: '海王中' },
    ],
  },
  {
    quizId: '52',
    question:
      '葉瀬中囲碁部編より問題です。\n第四回 北区中学夏期囲碁大会で男子一回戦で敗北した高校は？',
    options: [
      { optionId: '0', text: '川萩中' },
      { optionId: '1', text: '阿由中' },
      { optionId: '2', text: '浜地中' },
      { optionId: '3', text: '田井中' },
      { optionId: '4', text: '葉瀬中' },
    ],
  },
  {
    quizId: '53',
    question:
      'ヒカルの通っている中学校の元の案は実在する学校名だったため葉瀬中に変更になりましたが、元の案での校名は何？',
    options: [
      { optionId: '0', text: '多良中' },
      { optionId: '1', text: '加令中' },
      { optionId: '2', text: '安治中' },
      { optionId: '3', text: '山目中' },
      { optionId: '4', text: '伊香中' },
    ],
  },
  {
    quizId: '54',
    question:
      '葉瀬中囲碁部編より問題です。\n第四回 北区中学夏期囲碁大会での海王中との試合で塔矢アキラと打っている時、佐為の『13の四』を無視してヒカルが打った手は？',
    options: [
      { optionId: '0', text: '11の八' },
      { optionId: '1', text: '4の十四' },
      { optionId: '2', text: '3の十二' },
      { optionId: '3', text: '12の十二' },
      { optionId: '4', text: '8の五' },
    ],
  },
  {
    quizId: '55',
    question:
      '葉瀬中囲碁部編より問題です。\n海王中との試合での塔矢アキラとの対局でヒカルが打った代わりに訪れた、第14期NCC杯で対局していたのは？',
    options: [
      { optionId: '0', text: '加藤紀基、藤沢喜久夫' },
      { optionId: '1', text: '今村俊太、高木昭一' },
      { optionId: '2', text: '秋山四朗、村川大助' },
      { optionId: '3', text: '石倉運昇、杉村雅夫' },
      { optionId: '4', text: '小林秀樹、森田道広' },
    ],
  },
  {
    quizId: '56',
    question: '和谷のインターネット囲碁での登録名は？',
    options: [
      { optionId: '0', text: 'zelda' },
      { optionId: '1', text: 'flow' },
      { optionId: '2', text: 'bloody' },
      { optionId: '3', text: 'fencer' },
      { optionId: '4', text: 'arrows' },
    ],
  },
  {
    quizId: '57',
    question: 'プロ試験予選での塔矢アキラの初戦の相手は？',
    options: [
      { optionId: '0', text: '福井雄太' },
      { optionId: '1', text: '和谷義高' },
      { optionId: '2', text: '飯島良' },
      { optionId: '3', text: '奈瀬明日美' },
      { optionId: '4', text: '小宮英二' },
    ],
  },
  {
    quizId: '58',
    question: 'プロ試験予選での塔矢アキラの番号は？',
    options: [
      { optionId: '0', text: '7番' },
      { optionId: '1', text: '12番' },
      { optionId: '2', text: '15番' },
      { optionId: '3', text: '20番' },
      { optionId: '4', text: '26番' },
    ],
  },
  {
    quizId: '59',
    question: '第20回国際アマチュア囲碁カップで審判長を務めたのは？',
    options: [
      { optionId: '0', text: '森下' },
      { optionId: '1', text: '柿本' },
      { optionId: '2', text: '緒方' },
      { optionId: '3', text: '倉田' },
      { optionId: '4', text: '畑中' },
    ],
  },
  {
    quizId: '60',
    question: '第20回国際アマチュア囲碁カップの日本代表は？',
    options: [
      { optionId: '0', text: '島野' },
      { optionId: '1', text: '清水' },
      { optionId: '2', text: '井口' },
      { optionId: '3', text: '神野' },
      { optionId: '4', text: '西野' },
    ],
  },
  {
    quizId: '61',
    question: '第20回国際アマチュア囲碁カップの中国の代表は？',
    options: [
      { optionId: '0', text: '李臨新' },
      { optionId: '1', text: '劉小光' },
      { optionId: '2', text: '銭宇平' },
      { optionId: '3', text: '曹大元' },
      { optionId: '4', text: '江鋳久' },
    ],
  },
  {
    quizId: '62',
    question: 'インターネット囲碁でsaiに負けた韓国のプロ棋士は？',
    options: [
      { optionId: '0', text: '兪七段' },
      { optionId: '1', text: '劉七段' },
      { optionId: '2', text: '李七段' },
      { optionId: '3', text: '朴七段' },
      { optionId: '4', text: '徐七段' },
    ],
  },
  {
    quizId: '63',
    question: 'インターネット囲碁での塔矢アキラの登録名は？',
    options: [
      { optionId: '0', text: 'akira' },
      { optionId: '1', text: 'toya akira' },
      { optionId: '2', text: 'toya' },
      { optionId: '3', text: 'touya' },
      { optionId: '4', text: 'touya akira' },
    ],
  },
  {
    quizId: '64',
    question:
      'インターネット囲碁で塔矢アキラと打っている時に、以前の対局と同じ手で様子を見ていた佐為が正体がばれないようにと打った違う手は？',
    options: [
      { optionId: '0', text: '4の十四' },
      { optionId: '1', text: '11の八' },
      { optionId: '2', text: '3の十二' },
      { optionId: '3', text: '12の十二' },
      { optionId: '4', text: '8の五' },
    ],
  },
  {
    quizId: '65',
    question:
      '葉瀬中囲碁部編より問題です。\n塔矢アキラとのインターネット囲碁での再戦日にヒカルが指定した日時は？',
    options: [
      { optionId: '0', text: '今度の日曜 午前十時' },
      { optionId: '1', text: '今度の土曜 正午' },
      { optionId: '2', text: '今度の土曜 午前十時' },
      { optionId: '3', text: '今度の日曜 正午' },
      { optionId: '4', text: '今度の日曜 午後二時' },
    ],
  },
  {
    quizId: '66',
    question: '塔矢アキラのプロ試験本戦の初戦の結果は？',
    options: [
      { optionId: '0', text: '不戦敗' },
      { optionId: '1', text: '中押勝ち' },
      { optionId: '2', text: '3目半勝ち' },
      { optionId: '3', text: '4目半勝ち' },
      { optionId: '4', text: '半目勝ち' },
    ],
  },
  {
    quizId: '67',
    question: '塔矢アキラのプロ試験本戦の初戦の相手は？',
    options: [
      { optionId: '0', text: '津田' },
      { optionId: '1', text: '日野' },
      { optionId: '2', text: '大島' },
      { optionId: '3', text: '立山' },
      { optionId: '4', text: '石川' },
    ],
  },
  {
    quizId: '68',
    question: '塔矢アキラのプロ試験本戦の番号は？',
    options: [
      { optionId: '0', text: '12番' },
      { optionId: '1', text: '7番' },
      { optionId: '2', text: '15番' },
      { optionId: '3', text: '20番' },
      { optionId: '4', text: '26番' },
    ],
  },
  {
    quizId: '69',
    question:
      '葉瀬中囲碁部編より問題です。\n塔矢アキラがインターネットカフェに来たときにヒカルが開いていたページは？',
    options: [
      { optionId: '0', text: 'ジャンプのホームページ' },
      { optionId: '1', text: 'インターネット囲碁' },
      { optionId: '2', text: '葉瀬中のホームページ' },
      { optionId: '3', text: '日本棋院の囲碁公式ホームページ' },
      { optionId: '4', text: '詰碁' },
    ],
  },
  {
    quizId: '70',
    question:
      '佐為が宿っていた碁盤、ヒカルのじいちゃんの手に渡る前の持ち主は誰？',
    options: [
      { optionId: '0', text: 'じいちゃんの兄さん' },
      { optionId: '1', text: '古美術商' },
      { optionId: '2', text: '本因坊秀策' },
      { optionId: '3', text: 'じいちゃんの囲碁仲間' },
      { optionId: '4', text: '不明' },
    ],
  },
  {
    quizId: '71',
    question: '本因坊秀策の幼名は？',
    options: [
      { optionId: '0', text: '虎次郎' },
      { optionId: '1', text: '林太郎' },
      { optionId: '2', text: '與三郎' },
      { optionId: '3', text: '松之助' },
      { optionId: '4', text: '与三郎' },
    ],
  },
  {
    quizId: '72',
    question: 'ヒカルのじいちゃんが囲碁での自慢話に出ていた人物は？',
    options: [
      { optionId: '0', text: 'クツワ町の井上さん' },
      { optionId: '1', text: 'カッコウ町の田口さん' },
      { optionId: '2', text: 'ワラジ町の谷山さん' },
      { optionId: '3', text: 'ホタル町の伊藤さん' },
      { optionId: '4', text: 'アゲハ町の山本さん' },
    ],
  },
  {
    quizId: '73',
    question:
      '葉瀬中囲碁部編より問題です。\nじいちゃんがヒカルに買った碁盤と碁石の値段は？',
    options: [
      { optionId: '0', text: '5万' },
      { optionId: '1', text: '1万' },
      { optionId: '2', text: '2万' },
      { optionId: '3', text: '3万' },
      { optionId: '4', text: '10万' },
    ],
  },
  {
    quizId: '74',
    question:
      '葉瀬中囲碁部編より問題です。\nじいちゃんに買ってもらった碁盤でヒカルと佐為が初めて対局したときの、ヒカルの初手は？',
    options: [
      { optionId: '0', text: '3の四' },
      { optionId: '1', text: '17の四' },
      { optionId: '2', text: '7の十' },
      { optionId: '3', text: '16の四' },
      { optionId: '4', text: '3の三' },
    ],
  },
  {
    quizId: '75',
    question:
      '葉瀬中囲碁部編より問題です。\nヒカルが英語の参考書を買うために書店に行ったときに会った、海王中の岸本が手にしていた本は？',
    options: [
      { optionId: '0', text: '李歐' },
      { optionId: '1', text: '照柿' },
      { optionId: '2', text: '快楽と救済' },
      { optionId: '3', text: '閑人生生' },
      { optionId: '4', text: '半眼訥訥' },
    ],
  },
  {
    quizId: '76',
    question: '塔矢アキラがプロ棋士になったのはいつ？',
    options: [
      { optionId: '0', text: '中学一年' },
      { optionId: '1', text: '小学五年' },
      { optionId: '2', text: '小学六年' },
      { optionId: '3', text: '中学二年' },
      { optionId: '4', text: '中学三年' },
    ],
  },
  {
    quizId: '77',
    question: '院生試験は年に何回行われる？',
    options: [
      { optionId: '0', text: '4回' },
      { optionId: '1', text: '1回' },
      { optionId: '2', text: '2回' },
      { optionId: '3', text: '3回' },
      { optionId: '4', text: '5回' },
    ],
  },
  {
    quizId: '78',
    question:
      '院生編より問題です。\n院生試験を受験する際、ヒカルを推薦してくれたプロ棋士は？',
    options: [
      { optionId: '0', text: '緒方' },
      { optionId: '1', text: '桑原' },
      { optionId: '2', text: '塔矢行洋' },
      { optionId: '3', text: '塔矢アキラ' },
      { optionId: '4', text: '推薦なし' },
    ],
  },
  {
    quizId: '79',
    question:
      '院生編より問題です。\n院生試験を受験するために、当日必要なものでないのは？',
    options: [
      { optionId: '0', text: '健康診断書' },
      { optionId: '1', text: '院生志願書' },
      { optionId: '2', text: '履歴書' },
      { optionId: '3', text: '棋譜を3通' },
      { optionId: '4', text: '申込金と試験手合料あわせて1万3千6百5十円' },
    ],
  },
  {
    quizId: '80',
    question:
      '院生編より問題です。\nヒカルが院生試験の受験に持って行った三面打ちの棋譜、三谷との対局結果は？',
    options: [
      { optionId: '0', text: 'ヒカルの6目半勝ち' },
      { optionId: '1', text: 'ヒカルの2目半勝ち' },
      { optionId: '2', text: 'ヒカルの3目半勝ち' },
      { optionId: '3', text: 'ヒカルの5目半勝ち' },
      { optionId: '4', text: 'ヒカルの中押し勝ち' },
    ],
  },
  {
    quizId: '81',
    question:
      '院生編より問題です。\nヒカルが院生試験の受験に持って行った三面打ちの棋譜、加賀との対局結果は？',
    options: [
      { optionId: '0', text: 'ヒカルの6目半負け' },
      { optionId: '1', text: 'ヒカルの2目半勝ち' },
      { optionId: '2', text: 'ヒカルの3目半勝ち' },
      { optionId: '3', text: 'ヒカルの5目半負け' },
      { optionId: '4', text: 'ヒカルの中押し負け' },
    ],
  },
  {
    quizId: '82',
    question:
      '院生編より問題です。\n院生試験で院生師範と対局した時の置き石の数は？',
    options: [
      { optionId: '0', text: '三つ' },
      { optionId: '1', text: '二つ' },
      { optionId: '2', text: '四つ' },
      { optionId: '3', text: '五つ' },
      { optionId: '4', text: 'なし' },
    ],
  },
  {
    quizId: '83',
    question:
      '院生編より問題です。\n初登場時、伊角が自動販売機で買っていた飲み物は？',
    options: [
      { optionId: '0', text: 'C.C.Lemon' },
      { optionId: '1', text: 'サントリー烏龍茶' },
      { optionId: '2', text: 'ブラックコーヒー' },
      { optionId: '3', text: 'Coca-Cola' },
      { optionId: '4', text: 'パイナップル紅茶' },
    ],
  },
  {
    quizId: '84',
    question: '倉田は碁を覚えて何年でプロになった？',
    options: [
      { optionId: '0', text: '2年' },
      { optionId: '1', text: '1年' },
      { optionId: '2', text: '3年' },
      { optionId: '3', text: '4年' },
      { optionId: '4', text: '5年' },
    ],
  },
  {
    quizId: '85',
    question: '院生編より問題です。\n院生の研修日は？',
    options: [
      { optionId: '0', text: '毎週日曜と第2土曜' },
      { optionId: '1', text: '毎週日曜と第1土曜' },
      { optionId: '2', text: '毎週日曜と第3土曜' },
      { optionId: '3', text: '毎週日曜と第4土曜' },
      { optionId: '4', text: '毎週日曜と第5土曜' },
    ],
  },
  {
    quizId: '86',
    question:
      '院生編より問題です。\nヒカルと同時期に院生試験を受験した人数はヒカルを含めて何人？',
    options: [
      { optionId: '0', text: '3人' },
      { optionId: '1', text: '1人' },
      { optionId: '2', text: '2人' },
      { optionId: '3', text: '4人' },
      { optionId: '4', text: '5人' },
    ],
  },
  {
    quizId: '87',
    question: '院生編より問題です。\nヒカルの院生研修での初対局の相手は？',
    options: [
      { optionId: '0', text: '内田' },
      { optionId: '1', text: '今西' },
      { optionId: '2', text: '南' },
      { optionId: '3', text: '藤岡' },
      { optionId: '4', text: '保坂' },
    ],
  },
  {
    quizId: '88',
    question: '院生編より問題です。\n院生になりたてのヒカルの順位は？',
    options: [
      { optionId: '0', text: '2組の25位' },
      { optionId: '1', text: '2組の15位' },
      { optionId: '2', text: '2組の18位' },
      { optionId: '3', text: '2組の20位' },
      { optionId: '4', text: '2組の28位' },
    ],
  },
  {
    quizId: '89',
    question: '院生編より問題です。\n海王中の生徒で元院生だったのは？',
    options: [
      { optionId: '0', text: '岸本' },
      { optionId: '1', text: '日高' },
      { optionId: '2', text: '久野' },
      { optionId: '3', text: '青木' },
      { optionId: '4', text: '宇野' },
    ],
  },
  {
    quizId: '90',
    question: '院生編より問題です。\nヒカルが院生になった時点で和谷の順位は？',
    options: [
      { optionId: '0', text: '1組の6位' },
      { optionId: '1', text: '1組の3位' },
      { optionId: '2', text: '1組の5位' },
      { optionId: '3', text: '1組の8位' },
      { optionId: '4', text: '1組の11位' },
    ],
  },
  {
    quizId: '91',
    question: '院生編より問題です。\nヒカルが院生になった時点で越智の順位は？',
    options: [
      { optionId: '0', text: '1組の3位' },
      { optionId: '1', text: '1組の6位' },
      { optionId: '2', text: '1組の5位' },
      { optionId: '3', text: '1組の8位' },
      { optionId: '4', text: '1組の11位' },
    ],
  },
  {
    quizId: '92',
    question: '院生編より問題です。\n院生でいられるのは何歳まで？',
    options: [
      { optionId: '0', text: '18歳まで' },
      { optionId: '1', text: '15歳まで' },
      { optionId: '2', text: '20歳まで' },
      { optionId: '3', text: '22歳まで' },
      { optionId: '4', text: '25歳まで' },
    ],
  },
  {
    quizId: '93',
    question:
      '院生編より問題です。\nヒカルが院生の時、新初段シリーズで桑原先生と対局した新人棋士は？',
    options: [
      { optionId: '0', text: '真柴充' },
      { optionId: '1', text: '塔矢アキラ' },
      { optionId: '2', text: '辻岡忠男' },
      { optionId: '3', text: '村上信一' },
      { optionId: '4', text: '松永利之' },
    ],
  },
  {
    quizId: '94',
    question:
      '院生編より問題です。\nヒカルが院生の時、王座のタイトルを持っていたのは？',
    options: [
      { optionId: '0', text: '座間' },
      { optionId: '1', text: '塔矢行洋' },
      { optionId: '2', text: '一柳' },
      { optionId: '3', text: '芹澤' },
      { optionId: '4', text: '緒方' },
    ],
  },
  {
    quizId: '95',
    question:
      '院生編より問題です。\n新初段シリーズで塔矢アキラが対局した相手は？',
    options: [
      { optionId: '0', text: '座間' },
      { optionId: '1', text: '桑原' },
      { optionId: '2', text: '緒方' },
      { optionId: '3', text: '一柳' },
      { optionId: '4', text: '倉田' },
    ],
  },
  {
    quizId: '96',
    question: '新初段シリーズで対局が行われる場所は？',
    options: [
      { optionId: '0', text: '幽玄の間' },
      { optionId: '1', text: '棋峰の間' },
      { optionId: '2', text: '雲鶴の間' },
      { optionId: '3', text: '桂の間' },
      { optionId: '4', text: '香雲の間' },
    ],
  },
  {
    quizId: '97',
    question: '幽玄の間に掛けられている掛軸の文字は？',
    options: [
      { optionId: '0', text: '深奥幽玄' },
      { optionId: '1', text: '深山幽谷' },
      { optionId: '2', text: '幽愁暗恨' },
      { optionId: '3', text: '幽趣佳境' },
      { optionId: '4', text: '幽寂閑雅' },
    ],
  },
  {
    quizId: '98',
    question: '座間先生の真剣になった時の癖は？',
    options: [
      { optionId: '0', text: '扇子の先をかじる' },
      { optionId: '1', text: '指関節を鳴らす' },
      { optionId: '2', text: '扇子を何度も開き閉じる' },
      { optionId: '3', text: '扇子を鳴らす' },
      { optionId: '4', text: '貧乏ゆすり' },
    ],
  },
  {
    quizId: '99',
    question: '平成12年度棋士採用試験を2位合格したのは？',
    options: [
      { optionId: '0', text: '辻岡忠男' },
      { optionId: '1', text: '真柴充' },
      { optionId: '2', text: '塔矢アキラ' },
      { optionId: '3', text: '村上信一' },
      { optionId: '4', text: '松永利之' },
    ],
  },
  {
    quizId: '100',
    question:
      '院生編より問題です。\n院生2月期のヒカルの順位は何位からスタートした？',
    options: [
      { optionId: '0', text: '2組の18位' },
      { optionId: '1', text: '2組の15位' },
      { optionId: '2', text: '2組の20位' },
      { optionId: '3', text: '2組の25位' },
      { optionId: '4', text: '2組の28位' },
    ],
  },
  {
    quizId: '101',
    question: '伊角が院生と同時期に辞めた囲碁の塾は？',
    options: [
      { optionId: '0', text: '九星会' },
      { optionId: '1', text: '名水会' },
      { optionId: '2', text: '棋英会' },
      { optionId: '3', text: '楽翔会' },
      { optionId: '4', text: '方円企画' },
    ],
  },
  {
    quizId: '102',
    question:
      '院生編より問題です。\nヒカルが院生になるのと同時期に葉瀬中囲碁部に入部した男子生徒は？',
    options: [
      { optionId: '0', text: '夏目' },
      { optionId: '1', text: '小池' },
      { optionId: '2', text: '岡村' },
      { optionId: '3', text: '矢部' },
      { optionId: '4', text: '上島' },
    ],
  },
  {
    quizId: '103',
    question:
      '院生編より問題です。\n院生のヒカルが囲碁部に顔を出したとき、あかりはいくつの置き石でヒカルと対局した？',
    options: [
      { optionId: '0', text: '25子' },
      { optionId: '1', text: '5子' },
      { optionId: '2', text: '10子' },
      { optionId: '3', text: '15子' },
      { optionId: '4', text: '20子' },
    ],
  },
  {
    quizId: '104',
    question:
      '特別編「－葉瀬中アクターズ－本能寺炎上」より問題です。\n明智光秀役だったのは？',
    options: [
      { optionId: '0', text: '三谷祐輝' },
      { optionId: '1', text: '進藤ヒカル' },
      { optionId: '2', text: '筒井公宏' },
      { optionId: '3', text: '加賀鉄男' },
      { optionId: '4', text: '藤崎あかり' },
    ],
  },
  {
    quizId: '105',
    question: '小学生編より問題です。\nヒカルが初めて会ったプロ棋士は誰？',
    options: [
      { optionId: '0', text: '白川七段' },
      { optionId: '1', text: '塔矢名人' },
      { optionId: '2', text: '緒方九段' },
      { optionId: '3', text: '桑原本因坊' },
      { optionId: '4', text: '芦原四段' },
    ],
  },
  {
    quizId: '106',
    question:
      '院生編より問題です。\n若獅子戦に出られるのは5月初めに発表される院生での順位が何位まで？',
    options: [
      { optionId: '0', text: '1組16位まで' },
      { optionId: '1', text: '1組10位まで' },
      { optionId: '2', text: '1組12位まで' },
      { optionId: '3', text: '1組20位まで' },
      { optionId: '4', text: '1組25位まで' },
    ],
  },
  {
    quizId: '107',
    question: '院生編より問題です。\n若獅子戦に出場するプロの選出条件は？',
    options: [
      { optionId: '0', text: '20歳以下で5段以下' },
      { optionId: '1', text: 'プロ5年以下で4段以下' },
      { optionId: '2', text: '18歳以下で4段以下' },
      { optionId: '3', text: 'プロ5年以下で3段以下' },
      { optionId: '4', text: '18歳以下で3段以下' },
    ],
  },
  {
    quizId: '108',
    question:
      '院生編より問題です。\n院生3月期のヒカルの順位は何位からスタートした？',
    options: [
      { optionId: '0', text: '2組の25位' },
      { optionId: '1', text: '2組の15位' },
      { optionId: '2', text: '2組の18位' },
      { optionId: '3', text: '2組の20位' },
      { optionId: '4', text: '2組の28位' },
    ],
  },
  {
    quizId: '109',
    question: '第8回若獅子戦の優勝者は？',
    options: [
      { optionId: '0', text: '倉田厚' },
      { optionId: '1', text: '塔矢アキラ' },
      { optionId: '2', text: '芦原弘幸' },
      { optionId: '3', text: '冴木光二' },
      { optionId: '4', text: '不明' },
    ],
  },
  {
    quizId: '110',
    question: '次の内、真柴充の情報として間違っているものは？',
    options: [
      { optionId: '0', text: '第9回若獅子戦は2回戦敗退' },
      { optionId: '1', text: '千葉県出身' },
      { optionId: '2', text: '17歳でプロ棋士入り' },
      { optionId: '3', text: '溝口浩九段門下' },
      { optionId: '4', text: '新初段シリーズの対局相手は桑原本因坊' },
    ],
  },
  {
    quizId: '111',
    question:
      '院生編より問題です。\nヒカルが院生で1組に上がったのは何月期から？',
    options: [
      { optionId: '0', text: '4月期' },
      { optionId: '1', text: '1月期' },
      { optionId: '2', text: '2月期' },
      { optionId: '3', text: '3月期' },
      { optionId: '4', text: '5月期' },
    ],
  },
  {
    quizId: '112',
    question:
      '院生編より問題です。\nヒカルの1組に上がっての2戦目、福井との対局結果は？',
    options: [
      { optionId: '0', text: 'ヒカルの半目勝ち' },
      { optionId: '1', text: 'ヒカルの2目半勝ち' },
      { optionId: '2', text: '福井の半目勝ち' },
      { optionId: '3', text: '福井の2目半勝ち' },
      { optionId: '4', text: '福井の中押し勝ち' },
    ],
  },
  {
    quizId: '113',
    question:
      '院生編より問題です。\nヒカルの1組に上がっての3戦目の対局相手は？',
    options: [
      { optionId: '0', text: '和谷義高' },
      { optionId: '1', text: '伊角慎一郎' },
      { optionId: '2', text: '飯島良' },
      { optionId: '3', text: '奈瀬明日実' },
      { optionId: '4', text: '越智康介' },
    ],
  },
  {
    quizId: '114',
    question: '次の内、本名を登録名にインターネット囲碁をしているプロ棋士は？',
    options: [
      { optionId: '0', text: '一柳' },
      { optionId: '1', text: '倉田' },
      { optionId: '2', text: '緒方' },
      { optionId: '3', text: '佐々木' },
      { optionId: '4', text: '芹澤' },
    ],
  },
  {
    quizId: '115',
    question: 'ヒカルの碁の台湾版タイトルは？',
    options: [
      { optionId: '0', text: '棋霊王' },
      { optionId: '1', text: '棋魂' },
      { optionId: '2', text: '霊囲碁王' },
      { optionId: '3', text: '九星棋士' },
      { optionId: '4', text: '光之碁' },
    ],
  },
  {
    quizId: '116',
    question: 'ヒカルの碁の香港版タイトルは？',
    options: [
      { optionId: '0', text: '棋魂' },
      { optionId: '1', text: '棋霊王' },
      { optionId: '2', text: '霊囲碁王' },
      { optionId: '3', text: '九星棋士' },
      { optionId: '4', text: '光之碁' },
    ],
  },
  {
    quizId: '117',
    question: '第9回若獅子戦より問題です。\nヒカルは何位で若獅子戦に出場した？',
    options: [
      { optionId: '0', text: '1組16位' },
      { optionId: '1', text: '1組10位' },
      { optionId: '2', text: '1組12位' },
      { optionId: '3', text: '1組14位' },
      { optionId: '4', text: '1組18位' },
    ],
  },
  {
    quizId: '118',
    question: 'ヒカルの1学年下の下級生で、葉瀬中囲碁部の3代目部長は？',
    options: [
      { optionId: '0', text: '小池仁志' },
      { optionId: '1', text: '小池雄二' },
      { optionId: '2', text: '小池利行' },
      { optionId: '3', text: '夏目洋一郎' },
      { optionId: '4', text: '夏目貴志' },
    ],
  },
  {
    quizId: '119',
    question: '第9回若獅子戦より問題です。\n若獅子戦、ヒカルの一回戦の相手は？',
    options: [
      { optionId: '0', text: '村上信一 二段' },
      { optionId: '1', text: '辻岡忠男 初段' },
      { optionId: '2', text: '塔矢アキラ 初段' },
      { optionId: '3', text: '真柴充 初段' },
      { optionId: '4', text: '春木良子 初段' },
    ],
  },
  {
    quizId: '120',
    question: '次の内、若獅子戦の情報として間違っているものは？',
    options: [
      { optionId: '0', text: '院生での優勝者は一人しかいない' },
      { optionId: '1', text: '3日かけて行われる' },
      { optionId: '2', text: '初戦は院生が黒番' },
      { optionId: '3', text: '塔矢アキラが初めて参加したのは第9回若獅子戦' },
      { optionId: '4', text: '院生時に本田は3回戦進出したことがある' },
    ],
  },
  {
    quizId: '121',
    question: '第9回若獅子戦より問題です。\n塔矢アキラの一回戦の対局相手は？',
    options: [
      { optionId: '0', text: '本田敏則' },
      { optionId: '1', text: '福井雄太' },
      { optionId: '2', text: '和谷義高' },
      { optionId: '3', text: '越智康介' },
      { optionId: '4', text: '飯島良' },
    ],
  },
  {
    quizId: '122',
    question: '若獅子戦で院生時に一回戦で勝利したことがないのは？',
    options: [
      { optionId: '0', text: '塔矢アキラ' },
      { optionId: '1', text: '伊角慎一郎' },
      { optionId: '2', text: '越智康介' },
      { optionId: '3', text: '足立俊輝' },
      { optionId: '4', text: '本田敏則' },
    ],
  },
  {
    quizId: '123',
    question: '第9回若獅子戦より問題です。\n院生の内、二回戦で勝利したのは？',
    options: [
      { optionId: '0', text: '越智康介' },
      { optionId: '1', text: '伊角慎一郎' },
      { optionId: '2', text: '足立俊輝' },
      { optionId: '3', text: '和谷義高' },
      { optionId: '4', text: '該当なし' },
    ],
  },
  {
    quizId: '124',
    question: '和谷は誰との相性がいいと言っている？',
    options: [
      { optionId: '0', text: '越智康介' },
      { optionId: '1', text: '進藤ヒカル' },
      { optionId: '2', text: '福井雄太' },
      { optionId: '3', text: '本田敏則' },
      { optionId: '4', text: '伊角慎一郎' },
    ],
  },
  {
    quizId: '125',
    question: '越智が対局に負けた時に検討のためにこもる場所は？',
    options: [
      { optionId: '0', text: 'トイレ' },
      { optionId: '1', text: '自室' },
      { optionId: '2', text: '布団の中' },
      { optionId: '3', text: 'カラオケ' },
      { optionId: '4', text: '図書館' },
    ],
  },
  {
    quizId: '126',
    question: '院生編より問題です。\n福井に苦手意識を持っているのは誰と誰？',
    options: [
      { optionId: '0', text: '和谷と小宮' },
      { optionId: '1', text: '和谷と足立' },
      { optionId: '2', text: '和谷と本田' },
      { optionId: '3', text: '和谷と奈瀬' },
      { optionId: '4', text: '本田と奈瀬' },
    ],
  },
  {
    quizId: '127',
    question: '一番歴史の古いタイトルは？',
    options: [
      { optionId: '0', text: '本因坊' },
      { optionId: '1', text: '天元' },
      { optionId: '2', text: '名人' },
      { optionId: '3', text: '碁聖' },
      { optionId: '4', text: '王座' },
    ],
  },
  {
    quizId: '128',
    question: '第55期本因坊戦で桑原本因坊に挑戦したのは？',
    options: [
      { optionId: '0', text: '緒方精次' },
      { optionId: '1', text: '倉田厚' },
      { optionId: '2', text: '萩原昌彦' },
      { optionId: '3', text: '塔矢行洋' },
      { optionId: '4', text: '森下茂男' },
    ],
  },
  {
    quizId: '129',
    question: '桑原のフルネームは？',
    options: [
      { optionId: '0', text: '桑原仁' },
      { optionId: '1', text: '桑原忠行' },
      { optionId: '2', text: '桑原邦彦' },
      { optionId: '3', text: '桑原治' },
      { optionId: '4', text: '桑原正志' },
    ],
  },
  {
    quizId: '130',
    question: '元学生三冠の門脇が持っていたタイトルは？',
    options: [
      { optionId: '0', text: '学生名人、学生本因坊、学生十傑' },
      { optionId: '1', text: '学生名人、学生本因坊、学生王座' },
      { optionId: '2', text: '学生名人、学生十傑、学生王座' },
      { optionId: '3', text: '学生王座、学生本因坊、学生十傑' },
      { optionId: '4', text: '学生王座、学生棋聖、学生十傑' },
    ],
  },
  {
    quizId: '131',
    question: '院生編より問題です。\n佐為と対局した時の門脇の年齢は？',
    options: [
      { optionId: '0', text: '26歳' },
      { optionId: '1', text: '20歳' },
      { optionId: '2', text: '22歳' },
      { optionId: '3', text: '24歳' },
      { optionId: '4', text: '28歳' },
    ],
  },
  {
    quizId: '132',
    question:
      '院生編より問題です。\nプロ試験予選免除されるのはプロ試験前3か月の院生順位の平均が何位以上の場合？',
    options: [
      { optionId: '0', text: '1組8位以上' },
      { optionId: '1', text: '1組3位以上' },
      { optionId: '2', text: '1組5位以上' },
      { optionId: '3', text: '1組6位以上' },
      { optionId: '4', text: '1組10位以上' },
    ],
  },
  {
    quizId: '133',
    question: '院生編より問題です。\nヒカルのプロ試験直前の院生順位は？',
    options: [
      { optionId: '0', text: '1組7位' },
      { optionId: '1', text: '1組5位' },
      { optionId: '2', text: '1組10位' },
      { optionId: '3', text: '1組13位' },
      { optionId: '4', text: '1組15位' },
    ],
  },
  {
    quizId: '134',
    question: '第55期本因坊戦で緒方が封じ手となったのは第何局？',
    options: [
      { optionId: '0', text: '第7局' },
      { optionId: '1', text: '第1局' },
      { optionId: '2', text: '第4局' },
      { optionId: '3', text: '第5局' },
      { optionId: '4', text: '第6局' },
    ],
  },
  {
    quizId: '135',
    question: '第55期本因坊戦第7局の封じ手をホテルの金庫に預けた人は？',
    options: [
      { optionId: '0', text: '柿本' },
      { optionId: '1', text: '渡辺' },
      { optionId: '2', text: '船村' },
      { optionId: '3', text: '松永' },
      { optionId: '4', text: '萩原' },
    ],
  },
  {
    quizId: '136',
    question: '緒方が初めて封じ手をしたのは？',
    options: [
      { optionId: '0', text: '本因坊戦' },
      { optionId: '1', text: '棋聖戦' },
      { optionId: '2', text: '碁聖戦' },
      { optionId: '3', text: '天元戦' },
      { optionId: '4', text: '不明' },
    ],
  },
  {
    quizId: '137',
    question: '第55期本因坊戦第7局での緒方の封じ手は？',
    options: [
      { optionId: '0', text: '3の十二' },
      { optionId: '1', text: '4の十四' },
      { optionId: '2', text: '11の八' },
      { optionId: '3', text: '12の十二' },
      { optionId: '4', text: '8の五' },
    ],
  },
  {
    quizId: '138',
    question: '第1回 ピカイチキャラコンテスト第1位は？',
    options: [
      { optionId: '0', text: '藤原佐為' },
      { optionId: '1', text: '加賀鉄男' },
      { optionId: '2', text: '和谷義高' },
      { optionId: '3', text: '進藤ヒカル' },
      { optionId: '4', text: '塔矢アキラ' },
    ],
  },
  {
    quizId: '139',
    question: 'プロ試験の受験資格は何歳まで？',
    options: [
      { optionId: '0', text: '30歳' },
      { optionId: '1', text: '25歳' },
      { optionId: '2', text: '28歳' },
      { optionId: '3', text: '35歳' },
      { optionId: '4', text: '制限なし' },
    ],
  },
  {
    quizId: '140',
    question:
      'プロ試験編より問題です。\nプロ試験予選でのヒカルの初戦の対局相手は？',
    options: [
      { optionId: '0', text: '椿俊郎' },
      { optionId: '1', text: '福井雄太' },
      { optionId: '2', text: '片桐恭平' },
      { optionId: '3', text: '奈瀬明日実' },
      { optionId: '4', text: '飯島良' },
    ],
  },
  {
    quizId: '141',
    question: 'プロ試験編より問題です。\nプロ試験予選での対局時間は？',
    options: [
      { optionId: '0', text: '二時間 秒読み一手1分' },
      { optionId: '1', text: '一時間 秒読み一手1分' },
      { optionId: '2', text: '一時間半 秒読み一手1分' },
      { optionId: '3', text: '二時間半 秒読み一手1分' },
      { optionId: '4', text: '三時間 秒読み一手1分' },
    ],
  },
  {
    quizId: '142',
    question:
      '次の内、第1回 ピカイチキャラコンテストで最も順位が低かったのは？',
    options: [
      { optionId: '0', text: 'ヒカルの母' },
      { optionId: '1', text: '梅澤由香里四段' },
      { optionId: '2', text: 'ほったゆみ' },
      { optionId: '3', text: '小畑健' },
      { optionId: '4', text: '海王中囲碁部女子2' },
    ],
  },
  {
    quizId: '143',
    question:
      'プロ試験編より問題です。\nプロ試験予選初日にヒカルが着ていた服の文字は？',
    options: [
      { optionId: '0', text: '15' },
      { optionId: '1', text: '5' },
      { optionId: '2', text: '55' },
      { optionId: '3', text: 'GO' },
      { optionId: '4', text: '碁' },
    ],
  },
  {
    quizId: '144',
    question:
      'プロ試験編より問題です。\nプロ試験予選での食事の時間の打ち掛けとなる時間は？',
    options: [
      { optionId: '0', text: '0.520833333333333' },
      { optionId: '1', text: '0.479166666666667' },
      { optionId: '2', text: '0.493055555555556' },
      { optionId: '3', text: '0.5' },
      { optionId: '4', text: '0.541666666666667' },
    ],
  },
  {
    quizId: '145',
    question: 'プロ試験編より問題です。\nプロ試験予選初日に椿と食べた昼食は？',
    options: [
      { optionId: '0', text: 'ソバ' },
      { optionId: '1', text: 'ハンバーガー' },
      { optionId: '2', text: '弁当' },
      { optionId: '3', text: 'ラーメン' },
      { optionId: '4', text: '焼肉定食' },
    ],
  },
  {
    quizId: '146',
    question:
      'プロ試験編より問題です。\nプロ試験予選でのヒカルと椿の対局結果は？',
    options: [
      { optionId: '0', text: 'ヒカルの4目半負け' },
      { optionId: '1', text: 'ヒカルの半目負け' },
      { optionId: '2', text: 'ヒカルの1目半負け' },
      { optionId: '3', text: 'ヒカルの2目半負け' },
      { optionId: '4', text: 'ヒカルの3目半負け' },
    ],
  },
  {
    quizId: '147',
    question: 'プロ試験編より問題です。\nプロ試験予選での福井の番号は？',
    options: [
      { optionId: '0', text: '5' },
      { optionId: '1', text: '13' },
      { optionId: '2', text: '16' },
      { optionId: '3', text: '21' },
      { optionId: '4', text: '33' },
    ],
  },
  {
    quizId: '148',
    question: 'プロ試験編より問題です。\nプロ試験予選での福井の初戦の結果は？',
    options: [
      { optionId: '0', text: '34番相手に中押し勝ち' },
      { optionId: '1', text: '34番相手に2目半負け' },
      { optionId: '2', text: '15番相手に中押し勝ち' },
      { optionId: '3', text: '15番相手に2目半負け' },
      { optionId: '4', text: '15番相手に半目負け' },
    ],
  },
  {
    quizId: '149',
    question: '打ち掛けの時に相手の手番で休憩に入りたいと言っていたのは？',
    options: [
      { optionId: '0', text: '奈瀬明日美' },
      { optionId: '1', text: '福井雄太' },
      { optionId: '2', text: '飯島良' },
      { optionId: '3', text: '椿俊郎' },
      { optionId: '4', text: '進藤ヒカル' },
    ],
  },
  {
    quizId: '150',
    question:
      '次の内、第66局 「プロ試験予選2日目」の扉絵に描かれていないのは？',
    options: [
      { optionId: '0', text: '椿俊郎' },
      { optionId: '1', text: '藤原佐為' },
      { optionId: '2', text: '奈瀬明日美' },
      { optionId: '3', text: '福井雄太' },
      { optionId: '4', text: '飯島良' },
    ],
  },
  {
    quizId: '151',
    question: 'プロ試験編より問題です。\nプロ試験予選2日目のヒカルの昼食は？',
    options: [
      { optionId: '0', text: '弁当' },
      { optionId: '1', text: 'ソバ' },
      { optionId: '2', text: 'ハンバーガー' },
      { optionId: '3', text: 'ラーメン' },
      { optionId: '4', text: '焼肉定食' },
    ],
  },
  {
    quizId: '152',
    question:
      'プロ試験編より問題です。\nプロ試験予選でのヒカルと福井の対局結果は？',
    options: [
      { optionId: '0', text: 'ヒカルの3目半勝ち' },
      { optionId: '1', text: '福井の3目半勝ち' },
      { optionId: '2', text: '福井の1目半勝ち' },
      { optionId: '3', text: '福井の2目半勝ち' },
      { optionId: '4', text: 'ヒカルの1目半勝ち' },
    ],
  },
  {
    quizId: '153',
    question: 'プロ試験編より問題です。\nヒカルが椿に勝手につけたあだ名は？',
    options: [
      { optionId: '0', text: 'ヒゲゴジラ' },
      { optionId: '1', text: 'ヒゲゴリラ' },
      { optionId: '2', text: 'ひげもじゃ' },
      { optionId: '3', text: 'ヒゲオヤジ' },
      { optionId: '4', text: 'ヒゲジジイ' },
    ],
  },
  {
    quizId: '154',
    question:
      'プロ試験編より問題です。\nプロ試験予選三試合目の日に伊角が碁会所「石心」で対局していた相手は？',
    options: [
      { optionId: '0', text: '神宮寺' },
      { optionId: '1', text: '土庄' },
      { optionId: '2', text: '曽我' },
      { optionId: '3', text: '寺内' },
      { optionId: '4', text: '堂本' },
    ],
  },
  {
    quizId: '155',
    question:
      'プロ試験編より問題です。\nプロ試験予選での椿の第二局の対局相手は？',
    options: [
      { optionId: '0', text: '奈瀬明日美' },
      { optionId: '1', text: '進藤ヒカル' },
      { optionId: '2', text: '福井雄太' },
      { optionId: '3', text: '飯島良' },
      { optionId: '4', text: '片桐恭平' },
    ],
  },
  {
    quizId: '156',
    question:
      'プロ試験編より問題です。\nプロ試験予選で2勝2敗で第五局まで残っていなかったのは？',
    options: [
      { optionId: '0', text: '飯島' },
      { optionId: '1', text: '奈瀬' },
      { optionId: '2', text: '福井' },
      { optionId: '3', text: '松浦' },
      { optionId: '4', text: '平林' },
    ],
  },
  {
    quizId: '157',
    question:
      'プロ試験編より問題です。\nプロ試験予選での対局でヒカルが白番だった回数は？',
    options: [
      { optionId: '0', text: '2局' },
      { optionId: '1', text: '0局' },
      { optionId: '2', text: '1局' },
      { optionId: '3', text: '3局' },
      { optionId: '4', text: '4局' },
    ],
  },
  {
    quizId: '158',
    question:
      'プロ試験編より問題です。\n福井がプロ試験予選最終日に着ていた服の絵は？',
    options: [
      { optionId: '0', text: 'くま' },
      { optionId: '1', text: 'うし' },
      { optionId: '2', text: 'いぬ' },
      { optionId: '3', text: 'ねこ' },
      { optionId: '4', text: 'うさぎ' },
    ],
  },
  {
    quizId: '159',
    question: '囲碁の用語で、石は置かないが常に黒を持って打つことを何という？',
    options: [
      { optionId: '0', text: '定先' },
      { optionId: '1', text: '毎先' },
      { optionId: '2', text: '必先' },
      { optionId: '3', text: '確先' },
      { optionId: '4', text: '正先' },
    ],
  },
  {
    quizId: '160',
    question:
      'プロ試験編より問題です。\nヒカル、和谷、伊角の3人で碁会所に団体戦を申し込む時の条件は、勝利したら席料を無料にしてもらうことでしたが、敗北時の条件は？',
    options: [
      { optionId: '0', text: '席料払い、碁石洗い' },
      { optionId: '1', text: '席料2倍払い' },
      { optionId: '2', text: '席料払い、室内掃除' },
      { optionId: '3', text: '席料2倍払い、碁石洗い' },
      { optionId: '4', text: '席料2倍払い、室内掃除' },
    ],
  },
  {
    quizId: '161',
    question:
      'プロ試験編より問題です。\nヒカル、和谷、伊角の3人が囲碁サロン道玄坂で団体戦をした時の和谷の対局相手は？',
    options: [
      { optionId: '0', text: '曽我' },
      { optionId: '1', text: '堂本' },
      { optionId: '2', text: '河合' },
      { optionId: '3', text: '寺内' },
      { optionId: '4', text: '神宮寺' },
    ],
  },
  {
    quizId: '162',
    question: '囲碁サロン道玄坂の常連である河合の職業は？',
    options: [
      { optionId: '0', text: 'タクシー運転手' },
      { optionId: '1', text: '建築業' },
      { optionId: '2', text: '農家' },
      { optionId: '3', text: '宅配業者' },
      { optionId: '4', text: '無職' },
    ],
  },
  {
    quizId: '163',
    question:
      'プロ試験編より問題です。\n碁会所でのヒカル、和谷、伊角の団体戦で行った賭けで、結果に関係なく、席料がういたからと伊角が奢ったものは？',
    options: [
      { optionId: '0', text: '回転寿司' },
      { optionId: '1', text: 'ラーメン' },
      { optionId: '2', text: '焼肉' },
      { optionId: '3', text: 'カレー' },
      { optionId: '4', text: '牛丼' },
    ],
  },
  {
    quizId: '164',
    question:
      '第6回ふれい囲碁まつりに、あるプロ棋士の都合が悪くなり代理で訪れた塔矢アキラ。あるプロ棋士とは誰？',
    options: [
      { optionId: '0', text: '桜野千恵子' },
      { optionId: '1', text: '芦原弘幸' },
      { optionId: '2', text: '緒方精次' },
      { optionId: '3', text: '倉田厚' },
      { optionId: '4', text: '塔矢行洋' },
    ],
  },
  {
    quizId: '165',
    question:
      '第6回ふれい囲碁まつりのスポンサーになってくれている都議会議員の名前は？',
    options: [
      { optionId: '0', text: '栗本正助' },
      { optionId: '1', text: '久野春樹' },
      { optionId: '2', text: '中村茂蔵' },
      { optionId: '3', text: '諏訪真人' },
      { optionId: '4', text: '峰森忠司' },
    ],
  },
  {
    quizId: '166',
    question:
      '第6回ふれい囲碁まつりのスポンサーになってくれている都議会議員の後援会の糸井、塔矢アキラとの指導対局での置石の数は？',
    options: [
      { optionId: '0', text: '5子' },
      { optionId: '1', text: '6子' },
      { optionId: '2', text: '4子' },
      { optionId: '3', text: '3子' },
      { optionId: '4', text: 'なし' },
    ],
  },
  {
    quizId: '167',
    question:
      '第6回ふれい囲碁まつりでの指導対局で塔矢アキラは何人を同時に持碁にした？',
    options: [
      { optionId: '0', text: '4人' },
      { optionId: '1', text: '2人' },
      { optionId: '2', text: '3人' },
      { optionId: '3', text: '5人' },
      { optionId: '4', text: '6人' },
    ],
  },
  {
    quizId: '168',
    question:
      '第6回ふれい囲碁まつりのスポンサーになってくれている都議会議員の秘書、塔矢アキラとの指導対局で結果は？',
    options: [
      { optionId: '0', text: '63目の持碁' },
      { optionId: '1', text: '77目の持碁' },
      { optionId: '2', text: '59目の持碁' },
      { optionId: '3', text: '71目の持碁' },
      { optionId: '4', text: '83目の持碁' },
    ],
  },
  {
    quizId: '169',
    question:
      'プロ試験編より問題です。\nヒカルが洪秀英と初めて会った碁会所は？',
    options: [
      { optionId: '0', text: '柳' },
      { optionId: '1', text: '道玄坂' },
      { optionId: '2', text: '石心' },
      { optionId: '3', text: '道楽' },
      { optionId: '4', text: '囲碁サロン' },
    ],
  },
  {
    quizId: '170',
    question: '初登場時の洪秀英の年齢は？',
    options: [
      { optionId: '0', text: '12歳' },
      { optionId: '1', text: '9歳' },
      { optionId: '2', text: '10歳' },
      { optionId: '3', text: '11歳' },
      { optionId: '4', text: '13歳' },
    ],
  },
  {
    quizId: '171',
    question:
      'プロ試験編より問題です。\n洪秀英がヒカルに指導碁ならと、置いた石の数は？',
    options: [
      { optionId: '0', text: '2子' },
      { optionId: '1', text: '3子' },
      { optionId: '2', text: '4子' },
      { optionId: '3', text: '5子' },
      { optionId: '4', text: '置いていない' },
    ],
  },
  {
    quizId: '172',
    question: '週刊囲碁編集部の話によると、木之内さんが快勝したのは？',
    options: [
      { optionId: '0', text: '日中女流戦' },
      { optionId: '1', text: '日韓新鋭戦' },
      { optionId: '2', text: '日中俊英戦' },
      { optionId: '3', text: '日中天元戦' },
      { optionId: '4', text: '三星杯' },
    ],
  },
  {
    quizId: '173',
    question: '韓国の研究生は1組から10組までありますが、各組の人数は？',
    options: [
      { optionId: '0', text: '各10人' },
      { optionId: '1', text: '各5人' },
      { optionId: '2', text: '各15人' },
      { optionId: '3', text: '各20人' },
      { optionId: '4', text: '各25人' },
    ],
  },
  {
    quizId: '174',
    question:
      'プロ試験編より問題です。\n秀英との対局での、ヒカルの失着と思われた手は？',
    options: [
      { optionId: '0', text: '12の十二' },
      { optionId: '1', text: '3の十二' },
      { optionId: '2', text: '4の十四' },
      { optionId: '3', text: '11の八' },
      { optionId: '4', text: '8の五' },
    ],
  },
  {
    quizId: '175',
    question:
      'プロ試験編より問題です。\n洪秀英との初対局、ヒカルの対局結果は？',
    options: [
      { optionId: '0', text: 'ヒカルの1目半勝ち' },
      { optionId: '1', text: 'ヒカルの半目勝ち' },
      { optionId: '2', text: 'ヒカルの2目半勝ち' },
      { optionId: '3', text: 'ヒカルの3目半勝ち' },
      { optionId: '4', text: 'ヒカルの4目半勝ち' },
    ],
  },
  {
    quizId: '176',
    question: 'プロ試験編より問題です。\nプロ試験本戦の対局日は？',
    options: [
      { optionId: '0', text: '日曜、火曜、土曜' },
      { optionId: '1', text: '日曜、月曜、土曜' },
      { optionId: '2', text: '日曜、水曜、土曜' },
      { optionId: '3', text: '日曜、木曜、土曜' },
      { optionId: '4', text: '日曜、金曜、土曜' },
    ],
  },
  {
    quizId: '177',
    question:
      'プロ試験編より問題です。\nヒカルが受験した年のプロ試験本戦への参加者数は？',
    options: [
      { optionId: '0', text: '28名' },
      { optionId: '1', text: '19名' },
      { optionId: '2', text: '22名' },
      { optionId: '3', text: '25名' },
      { optionId: '4', text: '31名' },
    ],
  },
  {
    quizId: '178',
    question: 'プロ試験編より問題です。\nプロ試験本戦でのヒカルの番号は？',
    options: [
      { optionId: '0', text: '7番' },
      { optionId: '1', text: '3番' },
      { optionId: '2', text: '12番' },
      { optionId: '3', text: '21番' },
      { optionId: '4', text: '22番' },
    ],
  },
  {
    quizId: '179',
    question:
      'プロ試験編より問題です。\nプロ試験本戦でのヒカルの初戦の相手は？',
    options: [
      { optionId: '0', text: '飯島良' },
      { optionId: '1', text: '椿俊郎' },
      { optionId: '2', text: '大島博司' },
      { optionId: '3', text: '奈瀬明日美' },
      { optionId: '4', text: '足立俊輝' },
    ],
  },
  {
    quizId: '180',
    question: 'プロ試験編より問題です。\nプロ試験本戦での対局時間は？',
    options: [
      { optionId: '0', text: '3時間 秒読み一手1分' },
      { optionId: '1', text: '1時間 秒読み一手1分' },
      { optionId: '2', text: '1時間半 秒読み一手1分' },
      { optionId: '3', text: '2時間 秒読み一手1分' },
      { optionId: '4', text: '2時間半 秒読み一手1分' },
    ],
  },
  {
    quizId: '181',
    question:
      'プロ試験編より問題です。\nプロ試験本戦での、越智の初戦の相手は？',
    options: [
      { optionId: '0', text: '福井雄太' },
      { optionId: '1', text: '奈瀬明日美' },
      { optionId: '2', text: '小宮英二' },
      { optionId: '3', text: '石川一成' },
      { optionId: '4', text: '佐々木麻衣' },
    ],
  },
  {
    quizId: '182',
    question:
      'プロ試験編より問題です。\n鯨井8段の翌日に、越智家へ出張指導碁に呼ばれたプロ棋士は？',
    options: [
      { optionId: '0', text: '岩崎' },
      { optionId: '1', text: '萩原' },
      { optionId: '2', text: '船村' },
      { optionId: '3', text: '松永' },
      { optionId: '4', text: '渡辺' },
    ],
  },
  {
    quizId: '183',
    question: 'ヒカルが合格した年の棋士採用試験は？',
    options: [
      { optionId: '0', text: '平成13年度棋士採用試験' },
      { optionId: '1', text: '平成10年度棋士採用試験' },
      { optionId: '2', text: '平成11年度棋士採用試験' },
      { optionId: '3', text: '平成12年度棋士採用試験' },
      { optionId: '4', text: '平成14年度棋士採用試験' },
    ],
  },
  {
    quizId: '184',
    question:
      'プロ試験編より問題です。\nプロ試験本戦でヒカルが椿と対局したのは第何戦？',
    options: [
      { optionId: '0', text: '第7戦' },
      { optionId: '1', text: '第1戦' },
      { optionId: '2', text: '第13戦' },
      { optionId: '3', text: '第18戦' },
      { optionId: '4', text: '第21戦' },
    ],
  },
  {
    quizId: '185',
    question:
      'プロ試験本戦の対局が行われた、日本棋院囲碁研修センターの対局室に掛けてある扁額の文字は？',
    options: [
      { optionId: '0', text: '崇徳廣業' },
      { optionId: '1', text: '愚公移山' },
      { optionId: '2', text: '一意専心' },
      { optionId: '3', text: '確乎不動' },
      { optionId: '4', text: '寛仁大度' },
    ],
  },
  {
    quizId: '186',
    question:
      'プロ試験編より問題です。\n次の内、プロ試験本戦で初黒星が付いたのが最も早いのは？',
    options: [
      { optionId: '0', text: '本田' },
      { optionId: '1', text: 'ヒカル' },
      { optionId: '2', text: '和谷' },
      { optionId: '3', text: '伊角' },
      { optionId: '4', text: '越智' },
    ],
  },
  {
    quizId: '187',
    question: 'プロ試験編より問題です。\nプロ試験本戦で和谷の初黒星は何戦目？',
    options: [
      { optionId: '0', text: '第9戦' },
      { optionId: '1', text: '第7戦' },
      { optionId: '2', text: '第10戦' },
      { optionId: '3', text: '第12戦' },
      { optionId: '4', text: '第15戦' },
    ],
  },
  {
    quizId: '188',
    question:
      '第80局 「身代わり」の扉絵でヒカルがくわえているペットボトル飲料は？',
    options: [
      { optionId: '0', text: 'ハワイアンスプラッシュ' },
      { optionId: '1', text: 'パイナップル紅茶' },
      { optionId: '2', text: '緑茶' },
      { optionId: '3', text: 'C.C.Lemon' },
      { optionId: '4', text: 'Coca-Cola' },
    ],
  },
  {
    quizId: '189',
    question:
      'プロ試験編より問題です。\nプロ試験本戦でヒカルの初黒星は何戦目？',
    options: [
      { optionId: '0', text: '第10戦' },
      { optionId: '1', text: '第7戦' },
      { optionId: '2', text: '第9戦' },
      { optionId: '3', text: '第12戦' },
      { optionId: '4', text: '第15戦' },
    ],
  },
  {
    quizId: '190',
    question:
      'プロ試験編より問題です。\nプロ試験本戦で初黒星の日のヒカルについて正しいのは？',
    options: [
      { optionId: '0', text: '下痢になった' },
      { optionId: '1', text: '寝れなかった' },
      { optionId: '2', text: '食事がのどを通らなかった' },
      { optionId: '3', text: '帰りの電車を間違えた' },
      { optionId: '4', text: '自室で号泣した' },
    ],
  },
  {
    quizId: '191',
    question: 'プロ試験編より問題です。\nプロ試験本戦で伊角の初黒星は何戦目？',
    options: [
      { optionId: '0', text: '第12戦' },
      { optionId: '1', text: '第7戦' },
      { optionId: '2', text: '第9戦' },
      { optionId: '3', text: '第10戦' },
      { optionId: '4', text: '第15戦' },
    ],
  },
  {
    quizId: '192',
    question:
      'プロ試験編より問題です。\nプロ試験本戦での、和谷と越智の対局結果は？',
    options: [
      { optionId: '0', text: '越智の2目半勝ち' },
      { optionId: '1', text: '越智の半目勝ち' },
      { optionId: '2', text: '越智の3目半勝ち' },
      { optionId: '3', text: '越智の中押し勝ち' },
      { optionId: '4', text: '和谷の半目勝ち' },
    ],
  },
  {
    quizId: '193',
    question: 'プロ試験編より問題です。\nプロ試験本戦で越智の初黒星は何戦目？',
    options: [
      { optionId: '0', text: '第15戦目' },
      { optionId: '1', text: '第7戦' },
      { optionId: '2', text: '第9戦' },
      { optionId: '3', text: '第10戦' },
      { optionId: '4', text: '第12戦' },
    ],
  },
  {
    quizId: '194',
    question:
      'プロ試験編より問題です。\nプロ試験本戦での、伊角と越智の対局結果は？',
    options: [
      { optionId: '0', text: '伊角の中押し勝ち' },
      { optionId: '1', text: '伊角の5目半勝ち' },
      { optionId: '2', text: '伊角の3目半勝ち' },
      { optionId: '3', text: '越智の半目勝ち' },
      { optionId: '4', text: '越智の3目半勝ち' },
    ],
  },
  {
    quizId: '195',
    question:
      'プロ試験編より問題です。\n次の内、プロ試験本戦でヒカルに黒星をつけたのは？',
    options: [
      { optionId: '0', text: '大島博司' },
      { optionId: '1', text: '日野和彦' },
      { optionId: '2', text: '石川一成' },
      { optionId: '3', text: '片桐恭平' },
      { optionId: '4', text: '立山孝二' },
    ],
  },
  {
    quizId: '196',
    question:
      'プロ試験編より問題です。\nヒカルが椿のバイクに乗せてもらったのは、プロ試験本戦の第何戦が行われた日？',
    options: [
      { optionId: '0', text: '第21戦' },
      { optionId: '1', text: '第1戦' },
      { optionId: '2', text: '第7戦' },
      { optionId: '3', text: '第13戦' },
      { optionId: '4', text: '第18戦' },
    ],
  },
  {
    quizId: '197',
    question:
      'プロ試験編より問題です。\n越智の合格が決定したのは第何戦目終了時点でのこと？',
    options: [
      { optionId: '0', text: '第25戦' },
      { optionId: '1', text: '第23戦' },
      { optionId: '2', text: '第26戦' },
      { optionId: '3', text: '第29戦' },
      { optionId: '4', text: '第30戦' },
    ],
  },
  {
    quizId: '198',
    question:
      'プロ試験編より問題です。\n和谷がインターネット囲碁で別人のsaiを目撃したのは、プロ試験本戦第何戦が行われ日のこと？',
    options: [
      { optionId: '0', text: '第25戦' },
      { optionId: '1', text: '第23戦' },
      { optionId: '2', text: '第26戦' },
      { optionId: '3', text: '第29戦' },
      { optionId: '4', text: '第30戦' },
    ],
  },
  {
    quizId: '199',
    question: '院生師範の名前は？',
    options: [
      { optionId: '0', text: '篠田' },
      { optionId: '1', text: '石原' },
      { optionId: '2', text: '久野' },
      { optionId: '3', text: '島原' },
      { optionId: '4', text: '西岡' },
    ],
  },
  {
    quizId: '200',
    question: '森下茂男九段の息子の名前は？',
    options: [
      { optionId: '0', text: '一雄' },
      { optionId: '1', text: '茂吉' },
      { optionId: '2', text: '亮太' },
      { optionId: '3', text: '高貴' },
      { optionId: '4', text: '裕貴' },
    ],
  },
  {
    quizId: '202',
    question: '囲碁の8大タイトルに含まれないものは？',
    options: [
      { optionId: '0', text: '竜星' },
      { optionId: '1', text: '棋聖' },
      { optionId: '2', text: '王座' },
      { optionId: '3', text: '富士通杯' },
      { optionId: '4', text: '碁聖' },
    ],
  },
  {
    quizId: '203',
    question:
      'プロ試験編より問題です。\nこの時点で倉田の持っている連勝記録は？',
    options: [
      { optionId: '0', text: '25連勝' },
      { optionId: '1', text: '27連勝' },
      { optionId: '2', text: '16連勝' },
      { optionId: '3', text: '26連勝' },
      { optionId: '4', text: '38連勝' },
    ],
  },
  {
    quizId: '204',
    question:
      'プロ試験編より問題です。\nこの時点で桑原の持っている連勝記録は？',
    options: [
      { optionId: '0', text: '27連勝' },
      { optionId: '1', text: '25連勝' },
      { optionId: '2', text: '16連勝' },
      { optionId: '3', text: '26連勝' },
      { optionId: '4', text: '38連勝' },
    ],
  },
  {
    quizId: '205',
    question:
      'プロ試験編より問題です。\n次の内、プロ試験本戦でヒカルに黒星をつけたのは？',
    options: [
      { optionId: '0', text: '本田敏則' },
      { optionId: '1', text: '和谷義高' },
      { optionId: '2', text: '越智康介' },
      { optionId: '3', text: '伊角慎一郎' },
      { optionId: '4', text: '奈瀬明日美' },
    ],
  },
  {
    quizId: '206',
    question:
      'プロ試験編より問題です。\n次の内、プロ試験本戦で伊角が白星あげた相手は？',
    options: [
      { optionId: '0', text: '越智康介' },
      { optionId: '1', text: '本田敏則' },
      { optionId: '2', text: '和谷義高' },
      { optionId: '3', text: '進藤ヒカル' },
      { optionId: '4', text: '福井雄太' },
    ],
  },
  {
    quizId: '207',
    question:
      'プロ試験編より問題です。\n次の内、プロ試験本戦で和谷に黒星をつけたのは？',
    options: [
      { optionId: '0', text: '足立俊輝' },
      { optionId: '1', text: '金田淳' },
      { optionId: '2', text: '本田敏則' },
      { optionId: '3', text: '小宮英二' },
      { optionId: '4', text: '福井雄太' },
    ],
  },
  {
    quizId: '208',
    question:
      'プロ試験編より問題です。\nプロ試験本戦での白星が一番少なかったのは？',
    options: [
      { optionId: '0', text: '北原百合子' },
      { optionId: '1', text: '佐々木麻衣' },
      { optionId: '2', text: '石川一成' },
      { optionId: '3', text: '三浦佐紀' },
      { optionId: '4', text: '立山孝二' },
    ],
  },
  {
    quizId: '209',
    question:
      'プロ試験編より問題です。\n次の内、外来でプロ試験を受けていたのは？',
    options: [
      { optionId: '0', text: '日野和彦' },
      { optionId: '1', text: '中村隆' },
      { optionId: '2', text: '高倉伸之' },
      { optionId: '3', text: '金田淳' },
      { optionId: '4', text: '林達也' },
    ],
  },
  {
    quizId: '210',
    question:
      'プロ試験編より問題です。\nプロ試験本戦での、越智とヒカルの対局結果は？',
    options: [
      { optionId: '0', text: 'ヒカルの1目半勝ち' },
      { optionId: '1', text: 'ヒカルの半目勝ち' },
      { optionId: '2', text: 'ヒカルの2目半勝ち' },
      { optionId: '3', text: 'ヒカルの3目半勝ち' },
      { optionId: '4', text: 'ヒカルの4目半勝ち' },
    ],
  },
  {
    quizId: '211',
    question: '塔矢行洋は引退するまでに名人位を何連覇した？',
    options: [
      { optionId: '0', text: '防衛6連覇' },
      { optionId: '1', text: '防衛3連覇' },
      { optionId: '2', text: '防衛4連覇' },
      { optionId: '3', text: '防衛5連覇' },
      { optionId: '4', text: '防衛7連覇' },
    ],
  },
  {
    quizId: '212',
    question: 'プロ試験編より問題です。\n越智がプロ試験を合格した時の年齢は？',
    options: [
      { optionId: '0', text: '13歳' },
      { optionId: '1', text: '11歳' },
      { optionId: '2', text: '12歳' },
      { optionId: '3', text: '14歳' },
      { optionId: '4', text: '15歳' },
    ],
  },
  {
    quizId: '213',
    question: '次の内、道玄坂の客でないのは？',
    options: [
      { optionId: '0', text: '久米' },
      { optionId: '1', text: '寺内' },
      { optionId: '2', text: '堂本' },
      { optionId: '3', text: '河合' },
      { optionId: '4', text: '曽我' },
    ],
  },
  {
    quizId: '214',
    question:
      '塔矢行洋が第48期王座戦挑戦の合間をぬって防衛戦をしていたタイトルは？',
    options: [
      { optionId: '0', text: '天元' },
      { optionId: '1', text: '名人' },
      { optionId: '2', text: '碁聖' },
      { optionId: '3', text: '十段' },
      { optionId: '4', text: '棋聖' },
    ],
  },
  {
    quizId: '215',
    question:
      '塔矢行洋が王座戦挑戦の合間をぬって防衛していた天元戦に挑戦していたのは？',
    options: [
      { optionId: '0', text: '一柳' },
      { optionId: '1', text: '緒方' },
      { optionId: '2', text: '倉田' },
      { optionId: '3', text: '芹澤' },
      { optionId: '4', text: '桑原' },
    ],
  },
  {
    quizId: '216',
    question: '王座戦を制し,座間からタイトルを奪ったのは？',
    options: [
      { optionId: '0', text: '塔矢行洋' },
      { optionId: '1', text: '倉田厚' },
      { optionId: '2', text: '緒方精次' },
      { optionId: '3', text: '森下茂男' },
      { optionId: '4', text: '萩原昌彦' },
    ],
  },
  {
    quizId: '217',
    question: 'プロ入段後の塔矢アキラのプロ連勝記録はどこまで続いた？',
    options: [
      { optionId: '0', text: '26連勝' },
      { optionId: '1', text: '27連勝' },
      { optionId: '2', text: '16連勝' },
      { optionId: '3', text: '25連勝' },
      { optionId: '4', text: '38連勝' },
    ],
  },
  {
    quizId: '218',
    question: 'プロ編より問題です。\nヒカルの新初段シリーズの対局相手は？',
    options: [
      { optionId: '0', text: '塔矢行洋' },
      { optionId: '1', text: '倉田厚' },
      { optionId: '2', text: '緒方精次' },
      { optionId: '3', text: '森下茂男' },
      { optionId: '4', text: '萩原昌彦' },
    ],
  },
  {
    quizId: '219',
    question: '緒方の吸っている煙草は？',
    options: [
      { optionId: '0', text: 'LARK' },
      { optionId: '1', text: 'PEACE' },
      { optionId: '2', text: 'MEVIUS' },
      { optionId: '3', text: 'Seven Stars' },
      { optionId: '4', text: 'CASTER' },
    ],
  },
  {
    quizId: '220',
    question: '桑原の吸っている煙草は？',
    options: [
      { optionId: '0', text: 'PEACE' },
      { optionId: '1', text: 'LARK' },
      { optionId: '2', text: 'MEVIUS' },
      { optionId: '3', text: 'Seven Stars' },
      { optionId: '4', text: 'CASTER' },
    ],
  },
  {
    quizId: '221',
    question:
      'プロ編より問題です。\n新初段シリーズでヒカルと塔矢行洋のどちらが勝つかに、桑原と緒方が賭けたものは？',
    options: [
      { optionId: '0', text: '一万円' },
      { optionId: '1', text: '扇子' },
      { optionId: '2', text: '煙草' },
      { optionId: '3', text: '夕食' },
      { optionId: '4', text: 'コーヒー' },
    ],
  },
  {
    quizId: '222',
    question:
      'プロ編より問題です。\n新初段シリーズで佐為が塔矢行洋と打つときに、何目の差があると考えて打った？',
    options: [
      { optionId: '0', text: '15目' },
      { optionId: '1', text: '5目' },
      { optionId: '2', text: '8目' },
      { optionId: '3', text: '10目' },
      { optionId: '4', text: '20目' },
    ],
  },
  {
    quizId: '223',
    question:
      'プロ編より問題です。\n新初段シリーズで佐為が塔矢行洋と打つとき、初手にどのくらいの時間をかけた？',
    options: [
      { optionId: '0', text: '20分' },
      { optionId: '1', text: '20秒' },
      { optionId: '2', text: '40秒' },
      { optionId: '3', text: '2分' },
      { optionId: '4', text: '4分' },
    ],
  },
  {
    quizId: '224',
    question:
      'プロ編より問題です。\n新初段シリーズで佐為が塔矢行洋と打ったときの初手は？',
    options: [
      { optionId: '0', text: '3の三' },
      { optionId: '1', text: '3の四' },
      { optionId: '2', text: '17の四' },
      { optionId: '3', text: '7の十' },
      { optionId: '4', text: '16の四' },
    ],
  },
  {
    quizId: '225',
    question:
      'アマチュア囲碁フェスティバルで、3つ売れた市価8万の偽物の本カヤ碁盤の売値は？',
    options: [
      { optionId: '0', text: '20万円' },
      { optionId: '1', text: '12万円' },
      { optionId: '2', text: '15万円' },
      { optionId: '3', text: '22万円' },
      { optionId: '4', text: '26万円' },
    ],
  },
  {
    quizId: '226',
    question: 'ヒカルがじいちゃんに買ってもらった碁盤の材質は？',
    options: [
      { optionId: '0', text: 'カツラ' },
      { optionId: '1', text: 'イチョウ' },
      { optionId: '2', text: 'ヒノキ' },
      { optionId: '3', text: '新カヤ' },
      { optionId: '4', text: '本カヤ' },
    ],
  },
  {
    quizId: '227',
    question: 'ヒカルのじいちゃんが持っている碁盤の材質は？',
    options: [
      { optionId: '0', text: '本カヤ' },
      { optionId: '1', text: 'イチョウ' },
      { optionId: '2', text: 'ヒノキ' },
      { optionId: '3', text: '新カヤ' },
      { optionId: '4', text: 'カツラ' },
    ],
  },
  {
    quizId: '228',
    question:
      'アマチュア囲碁フェスティバルで、偽物の碁盤を売るのを手伝ったプロ棋士は？',
    options: [
      { optionId: '0', text: '御器曽' },
      { optionId: '1', text: '都築' },
      { optionId: '2', text: '広橋' },
      { optionId: '3', text: '瀬戸' },
      { optionId: '4', text: '外海' },
    ],
  },
  {
    quizId: '229',
    question:
      'アマチュア囲碁フェスティバルで、本因坊秀策が高松で署名したと偽り売られていた碁盤の売値は？',
    options: [
      { optionId: '0', text: '600万円' },
      { optionId: '1', text: '200万円' },
      { optionId: '2', text: '350万円' },
      { optionId: '3', text: '500万円' },
      { optionId: '4', text: '1000万円' },
    ],
  },
  {
    quizId: '230',
    question:
      'アマチュア囲碁フェスティバルでヒカルが初めて会った時の倉田厚の段位は？',
    options: [
      { optionId: '0', text: '六段' },
      { optionId: '1', text: '四段' },
      { optionId: '2', text: '五段' },
      { optionId: '3', text: '七段' },
      { optionId: '4', text: '八段' },
    ],
  },
  {
    quizId: '231',
    question: '森下門下の都筑さんの段位は？',
    options: [
      { optionId: '0', text: '七段' },
      { optionId: '1', text: '四段' },
      { optionId: '2', text: '五段' },
      { optionId: '3', text: '八段' },
      { optionId: '4', text: '六段' },
    ],
  },
  {
    quizId: '232',
    question: '新初段シリーズで勝利したのは？',
    options: [
      { optionId: '0', text: '越智康介' },
      { optionId: '1', text: '和谷義高' },
      { optionId: '2', text: '進藤ヒカル' },
      { optionId: '3', text: '塔矢アキラ' },
      { optionId: '4', text: '真柴充' },
    ],
  },
  {
    quizId: '233',
    question:
      'プロ編より問題です。\n新入段の免状授与式の日に持っていくものは？',
    options: [
      { optionId: '0', text: '健康診断書、履歴書' },
      { optionId: '1', text: '本人確認書類、印鑑' },
      { optionId: '2', text: '合格仮証書、通帳' },
      { optionId: '3', text: '通帳、印鑑' },
      { optionId: '4', text: '宣誓書' },
    ],
  },
  {
    quizId: '234',
    question:
      'プロ編より問題です。\n塔矢アキラが新入段の免状授与式を受けた年、倉田が受賞したものは？',
    options: [
      { optionId: '0', text: '最多勝利者、最多対局者' },
      { optionId: '1', text: '勝率第一位者、最多勝利者' },
      { optionId: '2', text: '連勝者、最多対局者' },
      { optionId: '3', text: '勝率第一位者、連勝者' },
      { optionId: '4', text: '優秀棋士者' },
    ],
  },
  {
    quizId: '235',
    question:
      'プロ編より問題です。\nヒカルが新入段の免状授与式を受けた年の、最優秀棋士に選ばれたのは？',
    options: [
      { optionId: '0', text: '塔矢行洋' },
      { optionId: '1', text: '倉田厚' },
      { optionId: '2', text: '塔矢アキラ' },
      { optionId: '3', text: '緒方精次' },
      { optionId: '4', text: '森下茂男' },
    ],
  },
  {
    quizId: '236',
    question:
      'プロ編より問題です。\nヒカルが新入段の免状授与式を受けた年、塔矢アキラが受賞したものは？',
    options: [
      { optionId: '0', text: '勝率第一位賞、連勝賞' },
      { optionId: '1', text: '最多勝利賞、最多対局賞' },
      { optionId: '2', text: '勝率第一位賞、最多勝利賞' },
      { optionId: '3', text: '連勝賞、最多対局賞' },
      { optionId: '4', text: '優秀棋士賞' },
    ],
  },
  {
    quizId: '237',
    question:
      '第2回 ピカイチキャラコンテストで圧倒的な得票数で第1位となったのは？',
    options: [
      { optionId: '0', text: '伊角慎一郎' },
      { optionId: '1', text: '藤原佐為' },
      { optionId: '2', text: '和谷義高' },
      { optionId: '3', text: '塔矢アキラ' },
      { optionId: '4', text: '進藤ヒカル' },
    ],
  },
  {
    quizId: '238',
    question: 'プロ編より問題です。\nヒカルの大手合の初戦の対局相手は？',
    options: [
      { optionId: '0', text: '塔矢アキラ二段' },
      { optionId: '1', text: '真柴充初段' },
      { optionId: '2', text: '山内克彦二段' },
      { optionId: '3', text: '宮島広美二段' },
      { optionId: '4', text: '辻岡忠男二段' },
    ],
  },
  {
    quizId: '239',
    question: '低段者の手合いが行われるのは？',
    options: [
      { optionId: '0', text: '水曜日' },
      { optionId: '1', text: '木曜日' },
      { optionId: '2', text: '金曜日' },
      { optionId: '3', text: '土曜日' },
      { optionId: '4', text: '月曜日' },
    ],
  },
  {
    quizId: '240',
    question: '塔矢行洋と緒方精次の十段戦五番勝負、第一局の結果は？',
    options: [
      { optionId: '0', text: '塔矢行洋の中押勝ち' },
      { optionId: '1', text: '緒方九段の3目半勝ち' },
      { optionId: '2', text: '緒方精次の不戦勝' },
      { optionId: '3', text: '緒方精次の中押勝ち' },
      { optionId: '4', text: '塔矢行洋の3目半勝ち' },
    ],
  },
  {
    quizId: '241',
    question: 'プロ編より問題です。\nヒカルの大手合い初戦の対戦日時は？',
    options: [
      { optionId: '0', text: '4月4日水曜日10時' },
      { optionId: '1', text: '4月5日木曜日9時' },
      { optionId: '2', text: '4月11日水曜日10時' },
      { optionId: '3', text: '4月12日木曜日9時' },
      { optionId: '4', text: '4月18日水曜日10時' },
    ],
  },
  {
    quizId: '242',
    question:
      '次の内、第2回 ピカイチキャラコンテストで最も順位が高かったのは？',
    options: [
      { optionId: '0', text: '梅澤由香里四段' },
      { optionId: '1', text: '小畑健' },
      { optionId: '2', text: '桑原本因坊' },
      { optionId: '3', text: 'ほったゆみ' },
      { optionId: '4', text: '越智康介' },
    ],
  },
  {
    quizId: '243',
    question: '塔矢行洋の入院した病院は？',
    options: [
      { optionId: '0', text: '中央武蔵病院' },
      { optionId: '1', text: '総合東京病院' },
      { optionId: '2', text: '済生会中央病院' },
      { optionId: '3', text: '水道橋病院' },
      { optionId: '4', text: '池上総合病院' },
    ],
  },
  {
    quizId: '244',
    question: '塔矢行洋が入院した日は？',
    options: [
      { optionId: '0', text: '44655' },
      { optionId: '1', text: '44656' },
      { optionId: '2', text: '44662' },
      { optionId: '3', text: '44663' },
      { optionId: '4', text: '44669' },
    ],
  },
  {
    quizId: '245',
    question: '塔矢行洋が倒れ、入院した時の病気は？',
    options: [
      { optionId: '0', text: '心筋こうそく' },
      { optionId: '1', text: '心筋症' },
      { optionId: '2', text: '脳卒中' },
      { optionId: '3', text: '胃かいよう' },
      { optionId: '4', text: '胸まくえん' },
    ],
  },
  {
    quizId: '246',
    question:
      'ヒカルが塔矢行洋の見舞いに行った時に、病室に見舞いに来ていた囲碁サロンの常連客は？',
    options: [
      { optionId: '0', text: '広瀬' },
      { optionId: '1', text: '北島' },
      { optionId: '2', text: '久米' },
      { optionId: '3', text: '堂本' },
      { optionId: '4', text: '神宮寺' },
    ],
  },
  {
    quizId: '247',
    question:
      '塔矢行洋が入院したことにより緒方九段の不戦勝となった十段戦の対局は？',
    options: [
      { optionId: '0', text: '第3局' },
      { optionId: '1', text: '第1局' },
      { optionId: '2', text: '第2局' },
      { optionId: '3', text: '第4局' },
      { optionId: '4', text: '第5局' },
    ],
  },
  {
    quizId: '249',
    question: 'ヒカルがプロ入りした時点での棋聖のタイトルホルダーは？',
    options: [
      { optionId: '0', text: '一柳' },
      { optionId: '1', text: '畑中' },
      { optionId: '2', text: '萩原' },
      { optionId: '3', text: '座間' },
      { optionId: '4', text: '芹澤' },
    ],
  },
  {
    quizId: '250',
    question: '第56期本因坊戦で桑原本因坊に挑戦したのは？',
    options: [
      { optionId: '0', text: '倉田厚' },
      { optionId: '1', text: '緒方精次' },
      { optionId: '2', text: '萩原昌彦' },
      { optionId: '3', text: '塔矢行洋' },
      { optionId: '4', text: '森下茂男' },
    ],
  },
  {
    quizId: '251',
    question:
      'インターネット囲碁での塔矢行洋とsaiの対局で、塔矢行洋は何手で投了した？',
    options: [
      { optionId: '0', text: '224手' },
      { optionId: '1', text: '198手' },
      { optionId: '2', text: '218手' },
      { optionId: '3', text: '232手' },
      { optionId: '4', text: '240手' },
    ],
  },
  {
    quizId: '252',
    question:
      '塔矢行洋とsaiが対局した翌日、ヒカルが塔矢行洋の元に訪れた時に病室にいたのは？',
    options: [
      { optionId: '0', text: '塔矢アキラの母' },
      { optionId: '1', text: '塔矢アキラ' },
      { optionId: '2', text: '天野' },
      { optionId: '3', text: '緒方精次' },
      { optionId: '4', text: '市川晴美' },
    ],
  },
  {
    quizId: '253',
    question: '王座戦本戦1回戦で倉田厚が対局した相手は？',
    options: [
      { optionId: '0', text: '鎌石義郎九段' },
      { optionId: '1', text: '松永利之六段' },
      { optionId: '2', text: '上前津宏七段' },
      { optionId: '3', text: '萩原昌彦九段' },
      { optionId: '4', text: '白川道夫七段' },
    ],
  },
  {
    quizId: '254',
    question: '倉田厚と塔矢アキラが初めて対局した手合いは？',
    options: [
      { optionId: '0', text: '名人戦 二次予選' },
      { optionId: '1', text: '天元戦 二次予選' },
      { optionId: '2', text: '王座戦 二次予選' },
      { optionId: '3', text: '棋聖戦 二次予選' },
      { optionId: '4', text: '本因坊戦 二次予選' },
    ],
  },
  {
    quizId: '255',
    question: 'ヒカルと倉田が一色碁を打った碁会所は？',
    options: [
      { optionId: '0', text: '天元' },
      { optionId: '1', text: '道玄坂' },
      { optionId: '2', text: '柳' },
      { optionId: '3', text: '石心' },
      { optionId: '4', text: '道楽' },
    ],
  },
  {
    quizId: '256',
    question: '塔矢行洋が引退するというニュースを、ヒカルはどこで知った？',
    options: [
      { optionId: '0', text: '囲碁サロン 天元' },
      { optionId: '1', text: '自宅' },
      { optionId: '2', text: 'ラーメン屋' },
      { optionId: '3', text: '日本棋院' },
      { optionId: '4', text: 'インターネットカフェ' },
    ],
  },
  {
    quizId: '257',
    question: '塔矢行洋が引退する直前、在位していたタイトルでないのは？',
    options: [
      { optionId: '0', text: '棋聖' },
      { optionId: '1', text: '碁聖' },
      { optionId: '2', text: '王座' },
      { optionId: '3', text: '名人' },
      { optionId: '4', text: '天元' },
    ],
  },
  {
    quizId: '258',
    question:
      '番外編おごって♡和谷くん！より問題です。\n冴木がプロ入段祝いで、森下しげ子にケーキを奢らされた場所は？',
    options: [
      { optionId: '0', text: '帝国ホテル' },
      { optionId: '1', text: '銀座の不二家' },
      { optionId: '2', text: '銀座コージーコーナー' },
      { optionId: '3', text: 'イタリアン・トマト' },
      { optionId: '4', text: 'シャトレーゼ' },
    ],
  },
  {
    quizId: '259',
    question:
      '番外編おごって♡和谷くん！ より問題です。\n和谷はプロ入段祝いで、森下しげ子に銀座の不二家で何を奢らされた？',
    options: [
      { optionId: '0', text: '苺のショートケーキを2個' },
      { optionId: '1', text: 'チョコレート生ケーキを2個' },
      { optionId: '2', text: 'モンブランを2個' },
      { optionId: '3', text: 'チーズケーキを2個' },
      { optionId: '4', text: '宇治抹茶のケーキを2個' },
    ],
  },
  {
    quizId: '260',
    question:
      '囲碁ゼミナールでの指導対局の時、ヒカルが宿泊したホテルで同室だったのは？',
    options: [
      { optionId: '0', text: '長江、横井' },
      { optionId: '1', text: '田所、島崎' },
      { optionId: '2', text: '宮下、平田' },
      { optionId: '3', text: '鈴本、福山' },
      { optionId: '4', text: '西崎、本村' },
    ],
  },
  {
    quizId: '261',
    question: '囲碁ゼミナールで公開早碁対局を打ったのは？',
    options: [
      { optionId: '0', text: '緒方精次十段と春木良子初段' },
      { optionId: '1', text: '芦原弘幸四段と西川恵美三段' },
      { optionId: '2', text: '緒方精次十段と西川恵美三段' },
      { optionId: '3', text: '芦原弘幸四段と春木良子初段' },
      { optionId: '4', text: '倉田厚六段と桜野千恵子二段' },
    ],
  },
  {
    quizId: '262',
    question: '囲碁ゼミナールで公開早碁対局の解説をしていたのは？',
    options: [
      { optionId: '0', text: '芦原弘幸四段と西川恵美三段' },
      { optionId: '1', text: '緒方精次十段と春木良子初段' },
      { optionId: '2', text: '緒方精次十段と西川恵美三段' },
      { optionId: '3', text: '芦原弘幸四段と春木良子初段' },
      { optionId: '4', text: '倉田厚六段と桜野千恵子二段' },
    ],
  },
  {
    quizId: '263',
    question: '佐為が囲碁で対局し勝った最後の相手は？',
    options: [
      { optionId: '0', text: '緒方精次' },
      { optionId: '1', text: '進藤ヒカル' },
      { optionId: '2', text: '塔矢行洋' },
      { optionId: '3', text: '塔矢アキラ' },
      { optionId: '4', text: '藤崎あかり' },
    ],
  },
  {
    quizId: '264',
    question: '佐為が消えたのはいつ？',
    options: [
      { optionId: '0', text: 'ヒカルとの対局中' },
      { optionId: '1', text: 'ヒカルが寝ている間' },
      { optionId: '2', text: 'ヒカルの手合い中' },
      { optionId: '3', text: 'ヒカルが授業を受けている間' },
      { optionId: '4', text: 'ヒカルとの会話中' },
    ],
  },
  {
    quizId: '265',
    question: '佐為が虎次郎に出会った場所は？',
    options: [
      { optionId: '0', text: '因島' },
      { optionId: '1', text: '厳島' },
      { optionId: '2', text: '岩子島' },
      { optionId: '3', text: '斎島' },
      { optionId: '4', text: '生野島' },
    ],
  },
  {
    quizId: '266',
    question: 'ヒカルと一緒に因島に行ったのは？',
    options: [
      { optionId: '0', text: '河合' },
      { optionId: '1', text: '和谷' },
      { optionId: '2', text: '神宮寺' },
      { optionId: '3', text: '堂本' },
      { optionId: '4', text: 'あかり' },
    ],
  },
  {
    quizId: '267',
    question: '秀策記念館に飾ってある碁盤は？',
    options: [
      { optionId: '0', text: '母親と打っていた碁盤' },
      { optionId: '1', text: '本因坊戦で使われた碁盤' },
      { optionId: '2', text: '晩年に使っていた碁盤' },
      { optionId: '3', text: '棋譜並べで使っていた碁盤' },
      { optionId: '4', text: '本因坊として初めて使った碁盤' },
    ],
  },
  {
    quizId: '268',
    question: '因島を訪れた時に、秀策記念館の次に行った場所は？',
    options: [
      { optionId: '0', text: '竹原の宝泉寺' },
      { optionId: '1', text: '尾道の金蓮寺' },
      { optionId: '2', text: '尾道の長福寺' },
      { optionId: '3', text: '尾道の善行寺' },
      { optionId: '4', text: '竹原の浄念寺' },
    ],
  },
  {
    quizId: '269',
    question: '広島に訪れた時に寄った碁会所は？',
    options: [
      { optionId: '0', text: '囲碁クラス' },
      { optionId: '1', text: '囲碁サロン' },
      { optionId: '2', text: '囲碁さろん' },
      { optionId: '3', text: '道玄坂' },
      { optionId: '4', text: '石心' },
    ],
  },
  {
    quizId: '270',
    question: '広島に訪れた時に、碁会所で河合が賭けた金額は？',
    options: [
      { optionId: '0', text: '5千円' },
      { optionId: '1', text: '5百円' },
      { optionId: '2', text: '千円' },
      { optionId: '3', text: '1万円' },
      { optionId: '4', text: '5万円' },
    ],
  },
  {
    quizId: '271',
    question: '広島の碁会所で河合が賭け碁をした相手は？',
    options: [
      { optionId: '0', text: '周平' },
      { optionId: '1', text: '啓介' },
      { optionId: '2', text: '健二' },
      { optionId: '3', text: '明星' },
      { optionId: '4', text: '恵' },
    ],
  },
  {
    quizId: '272',
    question: '佐為が居なくなって以降、ヒカルが初めて対局した相手は？',
    options: [
      { optionId: '0', text: '周平' },
      { optionId: '1', text: '伊角' },
      { optionId: '2', text: '和谷' },
      { optionId: '3', text: 'じいちゃん' },
      { optionId: '4', text: '村上' },
    ],
  },
  {
    quizId: '273',
    question: '東京で秀策の墓がある場所は？',
    options: [
      { optionId: '0', text: '巣鴨の本妙寺' },
      { optionId: '1', text: '巣鴨の法福寺' },
      { optionId: '2', text: '江古田の蓮華寺' },
      { optionId: '3', text: '駒込の泰宗寺' },
      { optionId: '4', text: '駒込の西福寺' },
    ],
  },
  {
    quizId: '274',
    question: '日本棋院に残されている最も古い打碁集は？',
    options: [
      { optionId: '0', text: '忘憂清楽集' },
      { optionId: '1', text: '秀策棋譜 訥堂蔵' },
      { optionId: '2', text: '御城碁' },
      { optionId: '3', text: '国技観光' },
      { optionId: '4', text: '敲玉余韵' },
    ],
  },
  {
    quizId: '275',
    question:
      'ヒカルに尋ねられて藤原佐為が平安時代にいたか調べてくれた、葉瀬中の社会の先生は？',
    options: [
      { optionId: '0', text: '松井先生' },
      { optionId: '1', text: '鈴木先生' },
      { optionId: '2', text: '勝俣先生' },
      { optionId: '3', text: '上原先生' },
      { optionId: '4', text: '北村先生' },
    ],
  },
  {
    quizId: '276',
    question:
      '塔矢アキラが、大手合と若獅子戦を休んだヒカルの下へ訪れた時、ヒカルは葉瀬中のどこにいた？',
    options: [
      { optionId: '0', text: '図書室' },
      { optionId: '1', text: '理科室' },
      { optionId: '2', text: '職員室' },
      { optionId: '3', text: '3-2教室' },
      { optionId: '4', text: '音楽室' },
    ],
  },
  {
    quizId: '277',
    question:
      '伊角の中国修行編より問題です。\n次の内、伊角と共に中国へ行ったのは？',
    options: [
      { optionId: '0', text: '桜野千恵子' },
      { optionId: '1', text: '春木良子' },
      { optionId: '2', text: '西川恵美' },
      { optionId: '3', text: '和谷義高' },
      { optionId: '4', text: '倉田厚' },
    ],
  },
  {
    quizId: '278',
    question:
      '伊角の中国修行編より問題です。\n伊角を中国の親善試合に誘ったのは誰？',
    options: [
      { optionId: '0', text: '成澤' },
      { optionId: '1', text: '桜野' },
      { optionId: '2', text: '篠田' },
      { optionId: '3', text: '柿本' },
      { optionId: '4', text: '渡辺' },
    ],
  },
  {
    quizId: '279',
    question:
      '手合や研究会を連絡もなく休んでいるヒカルに会いに来た和谷と、ヒカルはどこで会った？',
    options: [
      { optionId: '0', text: '公園' },
      { optionId: '1', text: 'ラーメン屋' },
      { optionId: '2', text: '進藤家' },
      { optionId: '3', text: '葉瀬中' },
      { optionId: '4', text: '道玄坂前' },
    ],
  },
  {
    quizId: '280',
    question:
      '伊角の中国修行編より問題です。\n中国の親善試合に成澤先生が行かなかったのは何故？',
    options: [
      { optionId: '0', text: '突然のギックリ腰' },
      { optionId: '1', text: '子どもの急病' },
      { optionId: '2', text: '急性虫垂炎' },
      { optionId: '3', text: '突然のインフルエンザ' },
      { optionId: '4', text: 'ヘルニアの悪化' },
    ],
  },
  {
    quizId: '281',
    question:
      '伊角の中国修行編より問題です。\n伊角が中国の親善試合に行った時に初めて対局した相手は？',
    options: [
      { optionId: '0', text: '趙石' },
      { optionId: '1', text: '王星' },
      { optionId: '2', text: '劉安' },
      { optionId: '3', text: '楽平' },
      { optionId: '4', text: '楊海' },
    ],
  },
  {
    quizId: '282',
    question:
      '伊角の中国修行編より問題です。\n中国のプロ棋士の数はどのくらいと言っていた？',
    options: [
      { optionId: '0', text: '250人くらい' },
      { optionId: '1', text: '100人くらい' },
      { optionId: '2', text: '150人くらい' },
      { optionId: '3', text: '200人くらい' },
      { optionId: '4', text: '300人くらい' },
    ],
  },
  {
    quizId: '283',
    question: '中国にいる、和谷に似ている子は？',
    options: [
      { optionId: '0', text: '楽平' },
      { optionId: '1', text: '趙石' },
      { optionId: '2', text: '王星' },
      { optionId: '3', text: '劉安' },
      { optionId: '4', text: '楊海' },
    ],
  },
  {
    quizId: '284',
    question: '次の内、楊海が喋れない言葉は？',
    options: [
      { optionId: '0', text: 'この中には該当なし' },
      { optionId: '1', text: '中国語' },
      { optionId: '2', text: '日本語' },
      { optionId: '3', text: '韓国語' },
      { optionId: '4', text: '英語' },
    ],
  },
  {
    quizId: '285',
    question: '伊角の中国修行編より問題です。\n楊海さんの部屋は？',
    options: [
      { optionId: '0', text: '303' },
      { optionId: '1', text: '105' },
      { optionId: '2', text: '204' },
      { optionId: '3', text: '224' },
      { optionId: '4', text: '316' },
    ],
  },
  {
    quizId: '286',
    question: '伊角の中国修行編より問題です。\n中国にいる伊角に電話したのは？',
    options: [
      { optionId: '0', text: '伊角の父' },
      { optionId: '1', text: '伊角の母' },
      { optionId: '2', text: '和谷義高' },
      { optionId: '3', text: '院生師範' },
      { optionId: '4', text: '成澤先生' },
    ],
  },
  {
    quizId: '287',
    question:
      '伊角の中国修行編より問題です。\n伊角が楊海の部屋に泊めてもらう際、楊海が伊角の実力を見るために打った指導碁は何子置き？',
    options: [
      { optionId: '0', text: '2子' },
      { optionId: '1', text: '3子' },
      { optionId: '2', text: '4子' },
      { optionId: '3', text: '5子' },
      { optionId: '4', text: '置石なし' },
    ],
  },
  {
    quizId: '288',
    question:
      '伊角の中国修行編より問題です。\n中国棋院に訪れた時、伊角と対局してくれた中国のトッププロは？',
    options: [
      { optionId: '0', text: '王星' },
      { optionId: '1', text: '華松力' },
      { optionId: '2', text: '劉安' },
      { optionId: '3', text: '金康日' },
      { optionId: '4', text: '胡耀宇' },
    ],
  },
  {
    quizId: '289',
    question: '楊海、楽平の出身省は？',
    options: [
      { optionId: '0', text: '雲南省' },
      { optionId: '1', text: '広東省' },
      { optionId: '2', text: '四川省' },
      { optionId: '3', text: '湖南省' },
      { optionId: '4', text: '台湾省' },
    ],
  },
  {
    quizId: '290',
    question:
      '伊角の中国修行編より問題です。\n次の内、中国棋院のリーグ戦で伊角に負けていたのは？',
    options: [
      { optionId: '0', text: '陳怡' },
      { optionId: '1', text: '王尭' },
      { optionId: '2', text: '孔傑' },
      { optionId: '3', text: '古力' },
      { optionId: '4', text: '劉星' },
    ],
  },
  {
    quizId: '291',
    question: '第135局 「伊角VS楽平」の扉絵でミイラ男に仮装していたのは？',
    options: [
      { optionId: '0', text: '越智康介' },
      { optionId: '1', text: '和谷義高' },
      { optionId: '2', text: '伊角慎一郎' },
      { optionId: '3', text: '進藤ヒカル' },
      { optionId: '4', text: '塔矢アキラ' },
    ],
  },
  {
    quizId: '292',
    question:
      '伊角の中国修行編より問題です。\n伊角と楽平の初対局で、開始時間に遅れた伊角は持ち時間はどれだけ減らした？',
    options: [
      { optionId: '0', text: '20分' },
      { optionId: '1', text: '10分' },
      { optionId: '2', text: '15分' },
      { optionId: '3', text: '25分' },
      { optionId: '4', text: '30分' },
    ],
  },
  {
    quizId: '293',
    question: '伊角の中国修行編より問題です。\n伊角と楽平の初対局の結果は？',
    options: [
      { optionId: '0', text: '伊角の2目半勝ち' },
      { optionId: '1', text: '伊角の半目勝ち' },
      { optionId: '2', text: '伊角の1目半勝ち' },
      { optionId: '3', text: '伊角の3目半勝ち' },
      { optionId: '4', text: '伊角の中押し勝ち' },
    ],
  },
  {
    quizId: '294',
    question:
      '伊角の中国修行編より問題です。\n楊海と趙石の間で行われた賭けで、伊角が趙石に対局で勝てば楊海は深キョンのストラップを手に入れる代わりに、伊角が負ければ楊海は何を失う？',
    options: [
      { optionId: '0', text: 'MDプレーヤー' },
      { optionId: '1', text: '『ultra soul』のCD' },
      { optionId: '2', text: 'ゲームボーイアドバンス' },
      { optionId: '3', text: '映画のチケット' },
      { optionId: '4', text: 'プレイステーション2' },
    ],
  },
  {
    quizId: '295',
    question: '日本棋院棋士会会長は？',
    options: [
      { optionId: '0', text: '室田九段' },
      { optionId: '1', text: '石田九段' },
      { optionId: '2', text: '鎌石九段' },
      { optionId: '3', text: '宮野九段' },
      { optionId: '4', text: '平川九段' },
    ],
  },
  {
    quizId: '296',
    question: '夏目、小池、三谷の3人で参加した大会は？',
    options: [
      { optionId: '0', text: '第六回 北区中学夏期囲碁大会' },
      { optionId: '1', text: '第六回 南区中学夏期囲碁大会' },
      { optionId: '2', text: '第七回 南区中学冬期囲碁大会' },
      { optionId: '3', text: '第七回 北区中学冬期囲碁大会' },
      { optionId: '4', text: '第六回 北区中学冬期囲碁大会' },
    ],
  },
  {
    quizId: '297',
    question:
      '伊角の中国修行編より問題です。\n伊角が中国からの帰国時に見た新聞によると越智は誰に勝利していた？',
    options: [
      { optionId: '0', text: '真柴充' },
      { optionId: '1', text: '村上信一' },
      { optionId: '2', text: '和谷義高' },
      { optionId: '3', text: '辻岡忠男' },
      { optionId: '4', text: '冴木光二' },
    ],
  },
  {
    quizId: '298',
    question:
      '伊角の中国修行編より問題です。\n和谷と楽平はハライタのときに何を飲んだら治る？',
    options: [
      { optionId: '0', text: 'セーロ丸' },
      { optionId: '1', text: 'アカダマ' },
      { optionId: '2', text: 'キャベジン' },
      { optionId: '3', text: 'ワカマツ' },
      { optionId: '4', text: '梅干し' },
    ],
  },
  {
    quizId: '299',
    question: '次の内、伊角が中国から帰国した後、会ったのが最も早いのは？',
    options: [
      { optionId: '0', text: '和谷義高' },
      { optionId: '1', text: '進藤ヒカル' },
      { optionId: '2', text: '越智康介' },
      { optionId: '3', text: '本田敏則' },
      { optionId: '4', text: '福井雄太' },
    ],
  },
  {
    quizId: '300',
    question: '第57期本因坊戦の三次予選決勝での塔矢アキラの対局相手は？',
    options: [
      { optionId: '0', text: '萩原昌彦九段' },
      { optionId: '1', text: '白川道夫七段' },
      { optionId: '2', text: '松永利之六段' },
      { optionId: '3', text: '上前津宏七段' },
      { optionId: '4', text: '森下茂男九段' },
    ],
  },
  {
    quizId: '301',
    question: 'ヒカルが立ち直って日本棋院に行ったとき、最初に会ったのは？',
    options: [
      { optionId: '0', text: '桑原、坂巻' },
      { optionId: '1', text: '塔矢アキラ' },
      { optionId: '2', text: '桑原、柿本' },
      { optionId: '3', text: '柿本、坂巻' },
      { optionId: '4', text: '緒方' },
    ],
  },
  {
    quizId: '302',
    question: 'ヒカルが佐為が消えたことから立ち直り、最初に対局したのは？',
    options: [
      { optionId: '0', text: '村上信一二段' },
      { optionId: '1', text: '辻岡忠男二段' },
      { optionId: '2', text: '和谷義高二段' },
      { optionId: '3', text: '越智康介二段' },
      { optionId: '4', text: '塔矢アキラ三段' },
    ],
  },
  {
    quizId: '303',
    question: '中学三年生時のヒカルの担任は？',
    options: [
      { optionId: '0', text: '鈴木先生' },
      { optionId: '1', text: '勝俣先生' },
      { optionId: '2', text: '松井先生' },
      { optionId: '3', text: '上原先生' },
      { optionId: '4', text: '北村先生' },
    ],
  },
  {
    quizId: '304',
    question: '第六回 北区中学夏期囲碁大会での葉瀬中男子の結果は？',
    options: [
      { optionId: '0', text: '決勝で敗北' },
      { optionId: '1', text: '一回戦で敗北' },
      { optionId: '2', text: '二回戦で敗北' },
      { optionId: '3', text: '優勝' },
      { optionId: '4', text: '未出場' },
    ],
  },
  {
    quizId: '305',
    question: '名人戦1回戦での、進藤ヒカルの対局相手は？',
    options: [
      { optionId: '0', text: '塔矢アキラ三段' },
      { optionId: '1', text: '辻岡忠男二段' },
      { optionId: '2', text: '村上信一二段' },
      { optionId: '3', text: '和谷義高二段' },
      { optionId: '4', text: '越智康介二段' },
    ],
  },
  {
    quizId: '306',
    question: '王座戦2次予選2回戦での、塔矢アキラの対局相手は？',
    options: [
      { optionId: '0', text: '松永利之六段' },
      { optionId: '1', text: '萩原昌彦九段' },
      { optionId: '2', text: '白川道夫七段' },
      { optionId: '3', text: '上前津宏七段' },
      { optionId: '4', text: '森下茂男九段' },
    ],
  },
  {
    quizId: '307',
    question: '天元戦1次予選2回戦での、塔矢アキラの対局相手は？',
    options: [
      { optionId: '0', text: '上前津宏七段' },
      { optionId: '1', text: '萩原昌彦九段' },
      { optionId: '2', text: '白川道夫七段' },
      { optionId: '3', text: '松永利之六段' },
      { optionId: '4', text: '森下茂男九段' },
    ],
  },
  {
    quizId: '308',
    question: '塔矢行洋引退により空位の碁聖位を賭けて五番勝負で対局したのは？',
    options: [
      { optionId: '0', text: '緒方、乃木' },
      { optionId: '1', text: '一柳、畑中' },
      { optionId: '2', text: '芹澤、桑原' },
      { optionId: '3', text: '座間、畑中' },
      { optionId: '4', text: '芹澤、一柳' },
    ],
  },
  {
    quizId: '309',
    question: '塔矢行洋引退により空位の名人位を賭けて七番勝負で対局したのは？',
    options: [
      { optionId: '0', text: '一柳、畑中' },
      { optionId: '1', text: '緒方、乃木' },
      { optionId: '2', text: '芹澤、桑原' },
      { optionId: '3', text: '座間、畑中' },
      { optionId: '4', text: '芹澤、一柳' },
    ],
  },
  {
    quizId: '310',
    question: '第57期本因坊リーグ戦に残っていなかったのは？',
    options: [
      { optionId: '0', text: '都築' },
      { optionId: '1', text: '乃木' },
      { optionId: '2', text: '倉田' },
      { optionId: '3', text: '畑中' },
      { optionId: '4', text: '芹澤' },
    ],
  },
  {
    quizId: '311',
    question: '引退した塔矢行洋が契約した中国のチームは？',
    options: [
      { optionId: '0', text: '北京チーム' },
      { optionId: '1', text: '上海チーム' },
      { optionId: '2', text: '深圳チーム' },
      { optionId: '3', text: '香港チーム' },
      { optionId: '4', text: '広州チーム' },
    ],
  },
  {
    quizId: '312',
    question: '王星が所属しているチームは？',
    options: [
      { optionId: '0', text: '上海チーム' },
      { optionId: '1', text: '北京チーム' },
      { optionId: '2', text: '深圳チーム' },
      { optionId: '3', text: '香港チーム' },
      { optionId: '4', text: '広州チーム' },
    ],
  },
  {
    quizId: '313',
    question: '名人戦1次予選の前日にヒカルが打った相手は？',
    options: [
      { optionId: '0', text: '藤崎あかり' },
      { optionId: '1', text: 'じいちゃん' },
      { optionId: '2', text: '和谷義高' },
      { optionId: '3', text: '河合' },
      { optionId: '4', text: '堂本' },
    ],
  },
  {
    quizId: '314',
    question:
      '番外編 第1回 塔矢アキラより問題です。\n磯部秀樹の好きな飲み物は？',
    options: [
      { optionId: '0', text: 'バナナジュース' },
      { optionId: '1', text: 'オレンジジュース' },
      { optionId: '2', text: 'グレープジュース' },
      { optionId: '3', text: 'アップルジュース' },
      { optionId: '4', text: 'トマトジュース' },
    ],
  },
  {
    quizId: '315',
    question:
      '番外編 第1回 塔矢アキラより問題です。\nこの時点での塔矢アキラは塔矢行洋に置き石何個？',
    options: [
      { optionId: '0', text: '3子' },
      { optionId: '1', text: '2子' },
      { optionId: '2', text: '4子' },
      { optionId: '3', text: '5子' },
      { optionId: '4', text: '常先' },
    ],
  },
  {
    quizId: '316',
    question: '加賀をよく追い回している、葉瀬中の生活指導の教師は？',
    options: [
      { optionId: '0', text: 'カツマタ' },
      { optionId: '1', text: 'スズキ' },
      { optionId: '2', text: 'マツイ' },
      { optionId: '3', text: 'ウエハラ' },
      { optionId: '4', text: 'キタムラ' },
    ],
  },
  {
    quizId: '317',
    question:
      '番外編 第2回 加賀鉄男より問題です。\nプロがいるとの噂を聞き、囲碁部に入部したのは？',
    options: [
      { optionId: '0', text: '矢部' },
      { optionId: '1', text: '岡村' },
      { optionId: '2', text: '上島' },
      { optionId: '3', text: '小池' },
      { optionId: '4', text: '夏目' },
    ],
  },
  {
    quizId: '318',
    question:
      '番外編 第2回 加賀鉄男より問題です。\n6枚落ちの加賀に将棋で負けて、囲碁部に入部することになったのは？',
    options: [
      { optionId: '0', text: '岡村' },
      { optionId: '1', text: '矢部' },
      { optionId: '2', text: '上島' },
      { optionId: '3', text: '小池' },
      { optionId: '4', text: '夏目' },
    ],
  },
  {
    quizId: '319',
    question:
      '番外編 第3回 奈瀬明日美より問題です。\n奈瀬明日実が訪れた碁会所は？',
    options: [
      { optionId: '0', text: '道楽' },
      { optionId: '1', text: '石心' },
      { optionId: '2', text: '道玄坂' },
      { optionId: '3', text: '柳' },
      { optionId: '4', text: '天元' },
    ],
  },
  {
    quizId: '320',
    question:
      '番外編 第3回 奈瀬明日美より問題です。\n碁会所で奈瀬が対局した相手は？',
    options: [
      { optionId: '0', text: '土庄' },
      { optionId: '1', text: '神宮寺' },
      { optionId: '2', text: '曽我' },
      { optionId: '3', text: '寺内' },
      { optionId: '4', text: '堂本' },
    ],
  },
  {
    quizId: '321',
    question:
      '番外編 第4回 三谷祐輝より問題です。\n三谷が欲しがっていたものは？',
    options: [
      { optionId: '0', text: 'ポータブルMDプレーヤー' },
      { optionId: '1', text: 'ゲームボーイカラー' },
      { optionId: '2', text: 'ドリームキャスト' },
      { optionId: '3', text: 'MDコンポ' },
      { optionId: '4', text: 'コミック' },
    ],
  },
  {
    quizId: '322',
    question:
      '番外編 第4回 三谷祐輝より問題です。\n修さんがダケさんに依頼の電話をした、ダケさんが大抵いるスナックは？',
    options: [
      { optionId: '0', text: 'みどり' },
      { optionId: '1', text: 'さくら' },
      { optionId: '2', text: 'カサブランカ' },
      { optionId: '3', text: '涼香' },
      { optionId: '4', text: '雅' },
    ],
  },
  {
    quizId: '323',
    question:
      '番外編 第4回 三谷祐輝、柱コメントより問題です。\n『JC(ジャンプコミックス)3巻を読んでからもう一度読むことをお勧めします!! たぶん面白さ○○!!(当社比)』\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '555倍' },
      { optionId: '1', text: '1億倍' },
      { optionId: '2', text: '15倍' },
      { optionId: '3', text: '3割増し' },
      { optionId: '4', text: '5割増し' },
    ],
  },
  {
    quizId: '324',
    question:
      '番外編 第5回 倉田厚より問題です。\n競馬をしていた教育実習生の担当科目は？',
    options: [
      { optionId: '0', text: '英語' },
      { optionId: '1', text: '数学' },
      { optionId: '2', text: '国語' },
      { optionId: '3', text: '理科' },
      { optionId: '4', text: '社会' },
    ],
  },
  {
    quizId: '325',
    question:
      '番外編 第5回 倉田厚より問題です。\n350万円賭けた人間のいる最終12レース。1着は？',
    options: [
      { optionId: '0', text: 'セトミサキ' },
      { optionId: '1', text: 'コノハズク' },
      { optionId: '2', text: 'ヒサトモ' },
      { optionId: '3', text: 'オオシマツムギ' },
      { optionId: '4', text: 'ヨシノザクラ' },
    ],
  },
  {
    quizId: '326',
    question:
      '番外編 第5回 倉田厚より問題です。\n倉田の言う、答えを出す最後の決め手は？',
    options: [
      { optionId: '0', text: '勝負勘' },
      { optionId: '1', text: '積み上げたデータ' },
      { optionId: '2', text: '入念な下調べ' },
      { optionId: '3', text: '闘志' },
      { optionId: '4', text: '経験' },
    ],
  },
  {
    quizId: '327',
    question: '番外編 第6回 藤原佐為より問題です。\nヒカルに当たったボールは？',
    options: [
      { optionId: '0', text: '野球ボール' },
      { optionId: '1', text: 'サッカーボール' },
      { optionId: '2', text: 'バスケットボール' },
      { optionId: '3', text: 'バレーボール' },
      { optionId: '4', text: 'ホッケーボール' },
    ],
  },
  {
    quizId: '328',
    question:
      '番外編 第6回 藤原佐為より問題です。\n将棋部の部室に置いてある、加賀の愛用の湯飲みに書かれている文字は？',
    options: [
      { optionId: '0', text: '魂' },
      { optionId: '1', text: '王将' },
      { optionId: '2', text: '将棋' },
      { optionId: '3', text: '金' },
      { optionId: '4', text: '茶' },
    ],
  },
  {
    quizId: '329',
    question:
      '番外編 第6回 藤原佐為より問題です。\n古美術商の店で売られていた、ヒカルが壊してしまった偽物の慶長の花器の売値は？',
    options: [
      { optionId: '0', text: '150万' },
      { optionId: '1', text: '30万' },
      { optionId: '2', text: '50万' },
      { optionId: '3', text: '100万' },
      { optionId: '4', text: '300万' },
    ],
  },
  {
    quizId: '330',
    question:
      '番外編 第6回 藤原佐為より問題です。\n笑うとガマガエルにそっくりな店主の名前は？',
    options: [
      { optionId: '0', text: '中村茂蔵' },
      { optionId: '1', text: '久野春樹' },
      { optionId: '2', text: '栗本正助' },
      { optionId: '3', text: '諏訪真人' },
      { optionId: '4', text: '峰森忠司' },
    ],
  },
  {
    quizId: '331',
    question: '佐為が嫌いなものは？',
    options: [
      { optionId: '0', text: 'ガマガエル' },
      { optionId: '1', text: '雷' },
      { optionId: '2', text: '幽霊' },
      { optionId: '3', text: '将棋の駒' },
      { optionId: '4', text: 'きゅうり' },
    ],
  },
  {
    quizId: '332',
    question:
      '番外編 第6回 藤原佐為より問題です。\n囲碁でヒカルが取り返した慶長の花器の仕掛けは？',
    options: [
      { optionId: '0', text: '水を注ぐと花模様が浮かぶ' },
      { optionId: '1', text: '水を注ぐと短冊模様が浮かぶ' },
      { optionId: '2', text: '水を注ぐ星模様が浮かぶ' },
      { optionId: '3', text: '弱い光を当てると花模様が浮かぶ' },
      { optionId: '4', text: '弱い光を当てると星模様が浮かぶ' },
    ],
  },
  {
    quizId: '333',
    question:
      '番外編 第6回 藤原佐為より問題です。\n割ってしまった加賀の湯呑みの代わりに、ヒカルが持っていった湯飲みの底の文字は？',
    options: [
      { optionId: '0', text: '栄寿司' },
      { optionId: '1', text: '鮨' },
      { optionId: '2', text: '㐂寿司' },
      { optionId: '3', text: '寿司政' },
      { optionId: '4', text: '月寿司' },
    ],
  },
  {
    quizId: '334',
    question: '第58期本因坊戦1次予選3回戦のヒカルの対局相手は？',
    options: [
      { optionId: '0', text: '川崎三段' },
      { optionId: '1', text: '遠山二段' },
      { optionId: '2', text: '辻岡二段' },
      { optionId: '3', text: '真柴二段' },
      { optionId: '4', text: '和谷二段' },
    ],
  },
  {
    quizId: '335',
    question:
      '川崎三段との手合いで、昼食の打ち掛け中にヒカルが売店で買ったものは？',
    options: [
      { optionId: '0', text: '扇子' },
      { optionId: '1', text: '本因坊秀策全集' },
      { optionId: '2', text: '湯呑' },
      { optionId: '3', text: '缶コーヒー' },
      { optionId: '4', text: '手ぬぐい' },
    ],
  },
  {
    quizId: '336',
    question: '倉田七段は韓国での三星火災杯で誰に惜敗してしまった？',
    options: [
      { optionId: '0', text: '安太善' },
      { optionId: '1', text: '徐彰元' },
      { optionId: '2', text: '金康日' },
      { optionId: '3', text: '張成豪' },
      { optionId: '4', text: '高永夏' },
    ],
  },
  {
    quizId: '337',
    question: '週刊碁の天野さんの後釜は？',
    options: [
      { optionId: '0', text: '古瀬村' },
      { optionId: '1', text: '土井' },
      { optionId: '2', text: '吉川' },
      { optionId: '3', text: '戸刈' },
      { optionId: '4', text: '相川' },
    ],
  },
  {
    quizId: '338',
    question: '北斗杯編より問題です。\n日中韓Jr.団体戦“北斗杯”の主催は？',
    options: [
      { optionId: '0', text: '株式会社 北斗通信システム' },
      { optionId: '1', text: '北斗興業 株式会社' },
      { optionId: '2', text: '株式会社 北斗スタッフ' },
      { optionId: '3', text: '株式会社 北斗プリント社' },
      { optionId: '4', text: '北斗電子工業 株式会社' },
    ],
  },
  {
    quizId: '339',
    question: '北斗杯編より問題です。\n北斗杯出場時の高永夏の年齢は？',
    options: [
      { optionId: '0', text: '16歳' },
      { optionId: '1', text: '14歳' },
      { optionId: '2', text: '15歳' },
      { optionId: '3', text: '17歳' },
      { optionId: '4', text: '18歳' },
    ],
  },
  {
    quizId: '340',
    question: '北斗杯編より問題です。\n日中韓Jr.団体戦“北斗杯”の開催日は？',
    options: [
      { optionId: '0', text: '38447' },
      { optionId: '1', text: '4/27-28' },
      { optionId: '2', text: '38415' },
      { optionId: '3', text: '38668' },
      { optionId: '4', text: '5/18-19' },
    ],
  },
  {
    quizId: '341',
    question: '北斗杯編より問題です。\n日中韓Jr.団体戦“北斗杯”の会場は？',
    options: [
      { optionId: '0', text: '七星ホテル' },
      { optionId: '1', text: '帝国ホテル' },
      { optionId: '2', text: '京王プラザホテル' },
      { optionId: '3', text: 'ホテル東京' },
      { optionId: '4', text: '栄楽ホテル' },
    ],
  },
  {
    quizId: '342',
    question:
      'ヒカルの初の高段者との手合いとなる、第58期本因坊戦2次予選1回戦での対局相手は？',
    options: [
      { optionId: '0', text: '御器曽七段' },
      { optionId: '1', text: '松永六段' },
      { optionId: '2', text: '上前津七段' },
      { optionId: '3', text: '森下九段' },
      { optionId: '4', text: '萩原九段' },
    ],
  },
  {
    quizId: '343',
    question: '葉瀬中の生徒で、関節を痛めて陸上部から囲碁部に入ったのは誰？',
    options: [
      { optionId: '0', text: '上島' },
      { optionId: '1', text: '夏目' },
      { optionId: '2', text: '岡村' },
      { optionId: '3', text: '小池' },
      { optionId: '4', text: '矢部' },
    ],
  },
  {
    quizId: '344',
    question: 'あかりが受験に備えて通っている塾は？',
    options: [
      { optionId: '0', text: 'ひのき真学塾' },
      { optionId: '1', text: '栄光ゼミ' },
      { optionId: '2', text: 'みつば学院' },
      { optionId: '3', text: '四谷学苑' },
      { optionId: '4', text: '関東進学寺' },
    ],
  },
  {
    quizId: '345',
    question: '伊角の新初段シリーズの対局相手は？',
    options: [
      { optionId: '0', text: '桑原' },
      { optionId: '1', text: '座間' },
      { optionId: '2', text: '乃木' },
      { optionId: '3', text: '一柳' },
      { optionId: '4', text: '緒方' },
    ],
  },
  {
    quizId: '346',
    question: 'プロ試験を3位で合格した本田は、何敗しつつ合格した？',
    options: [
      { optionId: '0', text: '6敗' },
      { optionId: '1', text: '4敗' },
      { optionId: '2', text: '5敗' },
      { optionId: '3', text: '7敗' },
      { optionId: '4', text: '8敗' },
    ],
  },
  {
    quizId: '347',
    question: 'ヒカルが三連星を打ったのは誰との対局？',
    options: [
      { optionId: '0', text: '門脇龍彦' },
      { optionId: '1', text: '真柴充' },
      { optionId: '2', text: '伊角慎一郎' },
      { optionId: '3', text: '三谷祐輝' },
      { optionId: '4', text: '洪秀英' },
    ],
  },
  {
    quizId: '348',
    question: '新初段シリーズでの伊角の対局結果は？',
    options: [
      { optionId: '0', text: '伊角の6目半勝ち' },
      { optionId: '1', text: '伊角の半目勝ち' },
      { optionId: '2', text: '伊角の2目半勝ち' },
      { optionId: '3', text: '伊角の2目半負け' },
      { optionId: '4', text: '伊角の6目半勝ち' },
    ],
  },
  {
    quizId: '349',
    question: '社清春の師匠は？',
    options: [
      { optionId: '0', text: '吉川八段' },
      { optionId: '1', text: '船村九段' },
      { optionId: '2', text: '溝口九段' },
      { optionId: '3', text: '江波九段' },
      { optionId: '4', text: '石川八段' },
    ],
  },
  {
    quizId: '350',
    question: '北斗杯の代表選抜戦で東京に訪れた関西棋院の棋士は？',
    options: [
      { optionId: '0', text: '社初段、津坂三段' },
      { optionId: '1', text: '社初段、稲垣三段' },
      { optionId: '2', text: '社初段、秋山初段' },
      { optionId: '3', text: '社初段、川崎三段' },
      { optionId: '4', text: '社初段のみ' },
    ],
  },
  {
    quizId: '351',
    question: '本田が社と対局した日の帰り道で買ったものは？',
    options: [
      { optionId: '0', text: '石焼き芋' },
      { optionId: '1', text: 'たい焼き' },
      { optionId: '2', text: 'タコ焼き' },
      { optionId: '3', text: '弁当' },
      { optionId: '4', text: 'ラムネ' },
    ],
  },
  {
    quizId: '352',
    question: '北斗杯1次予選1回戦の越智の対局相手は？',
    options: [
      { optionId: '0', text: '山田' },
      { optionId: '1', text: '坂東' },
      { optionId: '2', text: '生田' },
      { optionId: '3', text: '太田' },
      { optionId: '4', text: '本田' },
    ],
  },
  {
    quizId: '353',
    question: '北斗杯1次予選1回戦のヒカルの対局相手は？',
    options: [
      { optionId: '0', text: '本田' },
      { optionId: '1', text: '坂東' },
      { optionId: '2', text: '生田' },
      { optionId: '3', text: '太田' },
      { optionId: '4', text: '山田' },
    ],
  },
  {
    quizId: '354',
    question: '関西棋院の棋士の数は日本棋院の棋士の数と比べてどのくらい？',
    options: [
      { optionId: '0', text: '3分の1程' },
      { optionId: '1', text: '半分程' },
      { optionId: '2', text: '7割程' },
      { optionId: '3', text: '4分の1程' },
      { optionId: '4', text: '同じくらい' },
    ],
  },
  {
    quizId: '355',
    question: '第57期本因坊リーグ第5戦での、塔矢アキラの対局相手は？',
    options: [
      { optionId: '0', text: '緒方' },
      { optionId: '1', text: '芹澤' },
      { optionId: '2', text: '畑中' },
      { optionId: '3', text: '一柳' },
      { optionId: '4', text: '乃木' },
    ],
  },
  {
    quizId: '356',
    question: '第58期本因坊戦2次予選2回戦での、進藤ヒカルの対局相手は？',
    options: [
      { optionId: '0', text: '森下九段' },
      { optionId: '1', text: '松永六段' },
      { optionId: '2', text: '上前津七段' },
      { optionId: '3', text: '御器曽七段' },
      { optionId: '4', text: '萩原九段' },
    ],
  },
  {
    quizId: '357',
    question:
      '篠田院生師範は誰との対局はいつもゆっくりした碁になると言っていた？',
    options: [
      { optionId: '0', text: '溝口' },
      { optionId: '1', text: '船村' },
      { optionId: '2', text: '吉川' },
      { optionId: '3', text: '江波' },
      { optionId: '4', text: '石川' },
    ],
  },
  {
    quizId: '358',
    question:
      '葉瀬中卒業式の後に囲碁部のメンバーの写真を撮るため、シャッターをきってくれたのは？',
    options: [
      { optionId: '0', text: 'のりちゃん' },
      { optionId: '1', text: 'さやかちゃん' },
      { optionId: '2', text: 'ゆのちゃん' },
      { optionId: '3', text: 'みやちゃん' },
      { optionId: '4', text: 'ひろちゃん' },
    ],
  },
  {
    quizId: '359',
    question: '葉瀬中卒業式後にあかりとヒカルの2ショット写真を撮ったのは？',
    options: [
      { optionId: '0', text: '金子' },
      { optionId: '1', text: '津田' },
      { optionId: '2', text: 'ヒカルの母' },
      { optionId: '3', text: '夏目' },
      { optionId: '4', text: 'タマ子先生' },
    ],
  },
  {
    quizId: '360',
    question: '第57期本因坊リーグ第6戦での、塔矢アキラの対局相手は？',
    options: [
      { optionId: '0', text: '芹澤' },
      { optionId: '1', text: '緒方' },
      { optionId: '2', text: '畑中' },
      { optionId: '3', text: '一柳' },
      { optionId: '4', text: '乃木' },
    ],
  },
  {
    quizId: '361',
    question: 'ヒカル達が合格した年の3人は何と呼ばれていた？',
    options: [
      { optionId: '0', text: 'ちびっ子3人組' },
      { optionId: '1', text: '中学ジュニア' },
      { optionId: '2', text: 'ミニマムルーキー' },
      { optionId: '3', text: '新参小人' },
      { optionId: '4', text: 'かけだしキッズ' },
    ],
  },
  {
    quizId: '362',
    question: '塔矢行洋引退により空位になった王座位を獲ったのは？',
    options: [
      { optionId: '0', text: '座間' },
      { optionId: '1', text: '乃木' },
      { optionId: '2', text: '緒方' },
      { optionId: '3', text: '畑中' },
      { optionId: '4', text: '一柳' },
    ],
  },
  {
    quizId: '363',
    question: '塔矢行洋引退により空位になった天元位を獲ったのは？',
    options: [
      { optionId: '0', text: '乃木' },
      { optionId: '1', text: '座間' },
      { optionId: '2', text: '緒方' },
      { optionId: '3', text: '畑中' },
      { optionId: '4', text: '一柳' },
    ],
  },
  {
    quizId: '364',
    question: '塔矢行洋引退により空位になった名人位を獲ったのは？',
    options: [
      { optionId: '0', text: '畑中' },
      { optionId: '1', text: '座間' },
      { optionId: '2', text: '乃木' },
      { optionId: '3', text: '緒方' },
      { optionId: '4', text: '一柳' },
    ],
  },
  {
    quizId: '365',
    question:
      '北斗杯編より問題です。\n北斗杯選抜戦の本戦に出場した棋士の内、最も若いのは？',
    options: [
      { optionId: '0', text: '越智二段' },
      { optionId: '1', text: '進藤初段' },
      { optionId: '2', text: '社初段' },
      { optionId: '3', text: '秋山初段' },
      { optionId: '4', text: '柴田二段' },
    ],
  },
  {
    quizId: '366',
    question:
      '北斗杯編より問題です。\n次の内、北斗杯選抜戦の本戦に出場した棋士の中で、日本棋院の棋士でないのは？',
    options: [
      { optionId: '0', text: '津坂三段' },
      { optionId: '1', text: '越智二段' },
      { optionId: '2', text: '稲垣三段' },
      { optionId: '3', text: '和谷二段' },
      { optionId: '4', text: '進藤初段' },
    ],
  },
  {
    quizId: '367',
    question:
      '北斗杯編より問題です。\n北斗杯選抜戦の本戦に出場した棋士の内、唯一の中部総本部の棋士は？',
    options: [
      { optionId: '0', text: '柴田二段' },
      { optionId: '1', text: '津坂三段' },
      { optionId: '2', text: '秋山初段' },
      { optionId: '3', text: '社初段' },
      { optionId: '4', text: '稲垣三段' },
    ],
  },
  {
    quizId: '368',
    question:
      '北斗杯編より問題です。\n北斗杯選抜戦本戦の一回戦での、和谷の対局相手は？',
    options: [
      { optionId: '0', text: '秋山初段' },
      { optionId: '1', text: '津坂三段' },
      { optionId: '2', text: '柴田二段' },
      { optionId: '3', text: '社初段' },
      { optionId: '4', text: '稲垣三段' },
    ],
  },
  {
    quizId: '369',
    question:
      '北斗杯編より問題です。\n中部総本部の棋院では北斗杯選抜戦の予選は何人で行われた？',
    options: [
      { optionId: '0', text: '2人' },
      { optionId: '1', text: '3人' },
      { optionId: '2', text: '6人' },
      { optionId: '3', text: '7人' },
      { optionId: '4', text: '行われていない' },
    ],
  },
  {
    quizId: '370',
    question:
      '北斗杯編より問題です。\n次の内、北斗杯選抜戦本戦の一回戦で白番だったのは？',
    options: [
      { optionId: '0', text: '社初段' },
      { optionId: '1', text: '和谷二段' },
      { optionId: '2', text: '進藤初段' },
      { optionId: '3', text: '越智二段' },
      { optionId: '4', text: '稲垣三段' },
    ],
  },
  {
    quizId: '371',
    question:
      '北斗杯編より問題です。\n北斗杯選抜戦本戦の一回戦での、越智の対局結果は？',
    options: [
      { optionId: '0', text: '越智の2目半勝ち' },
      { optionId: '1', text: '越智の半目勝ち' },
      { optionId: '2', text: '越智の3目半勝ち' },
      { optionId: '3', text: '越智の4目半勝ち' },
      { optionId: '4', text: '越智の中押し勝ち' },
    ],
  },
  {
    quizId: '372',
    question:
      '北斗杯編より問題です。\n北斗杯選抜戦本戦の二回戦での、社の初手は？',
    options: [
      { optionId: '0', text: '5の五' },
      { optionId: '1', text: '天元' },
      { optionId: '2', text: '3の三' },
      { optionId: '3', text: '4の四' },
      { optionId: '4', text: '6の六' },
    ],
  },
  {
    quizId: '373',
    question: '北斗杯編より問題です。\n北斗杯の日本チームの団長は？',
    options: [
      { optionId: '0', text: '倉田厚' },
      { optionId: '1', text: '緒方精次' },
      { optionId: '2', text: '冴木光二' },
      { optionId: '3', text: '芦原弘幸' },
      { optionId: '4', text: '桜野千恵子' },
    ],
  },
  {
    quizId: '374',
    question: '北斗杯編より問題です。\n北斗杯の韓国チームの団長は？',
    options: [
      { optionId: '0', text: '安太善' },
      { optionId: '1', text: '徐彰元' },
      { optionId: '2', text: '金康日' },
      { optionId: '3', text: '金相烈' },
      { optionId: '4', text: '張成豪' },
    ],
  },
  {
    quizId: '375',
    question:
      '北斗杯編より問題です。\n北斗杯前に高永夏が挑戦手合をした韓国のタイトルは？',
    options: [
      { optionId: '0', text: '国手' },
      { optionId: '1', text: '王位' },
      { optionId: '2', text: '王中王' },
      { optionId: '3', text: '碁王' },
      { optionId: '4', text: '十段' },
    ],
  },
  {
    quizId: '376',
    question:
      '北斗杯編より問題です。\n北斗杯選抜戦本戦の二回戦での、越智と和谷の対局結果は？',
    options: [
      { optionId: '0', text: '越智の中押し勝ち' },
      { optionId: '1', text: '越智の半目勝ち' },
      { optionId: '2', text: '越智の2目半勝ち' },
      { optionId: '3', text: '越智の3目半勝ち' },
      { optionId: '4', text: '越智の4目半勝ち' },
    ],
  },
  {
    quizId: '377',
    question: '北斗杯編より問題です。\n北斗通信システムの北斗杯担当室長は？',
    options: [
      { optionId: '0', text: '戸刈' },
      { optionId: '1', text: '相川' },
      { optionId: '2', text: '土井' },
      { optionId: '3', text: '吉川' },
      { optionId: '4', text: '古瀬村' },
    ],
  },
  {
    quizId: '378',
    question:
      '北斗杯編より問題です。\n北斗杯選抜戦本戦の二回戦での、ヒカルと社の対局結果は？',
    options: [
      { optionId: '0', text: 'ヒカルの中押し勝ち' },
      { optionId: '1', text: 'ヒカルの半目勝ち' },
      { optionId: '2', text: 'ヒカルの2目半勝ち' },
      { optionId: '3', text: 'ヒカルの3目半勝ち' },
      { optionId: '4', text: 'ヒカルの4目半勝ち' },
    ],
  },
  {
    quizId: '379',
    question:
      '北斗杯編より問題です。\n北斗杯選抜戦本戦での、越智と社の対局結果は？',
    options: [
      { optionId: '0', text: '社の中押し勝ち' },
      { optionId: '1', text: '社の半目勝ち' },
      { optionId: '2', text: '社の2目半勝ち' },
      { optionId: '3', text: '社の3目半勝ち' },
      { optionId: '4', text: '社の4目半勝ち' },
    ],
  },
  {
    quizId: '380',
    question:
      '北斗杯編より問題です。\n北斗杯で受付をしていた、北斗通信システムの女性社員は？',
    options: [
      { optionId: '0', text: '相川' },
      { optionId: '1', text: '戸刈' },
      { optionId: '2', text: '土井' },
      { optionId: '3', text: '吉川' },
      { optionId: '4', text: '古瀬村' },
    ],
  },
  {
    quizId: '381',
    question: '北斗杯編より問題です。\n北斗杯に出場した棋士の中で最年長は誰？',
    options: [
      { optionId: '0', text: '陸力' },
      { optionId: '1', text: '林日煥' },
      { optionId: '2', text: '王世振' },
      { optionId: '3', text: '高永夏' },
      { optionId: '4', text: '社清春' },
    ],
  },
  {
    quizId: '382',
    question: '北斗杯編より問題です。\n北斗杯の中国チームの団長は？',
    options: [
      { optionId: '0', text: '楊海' },
      { optionId: '1', text: '陳学明' },
      { optionId: '2', text: '王星' },
      { optionId: '3', text: '劉安' },
      { optionId: '4', text: '陳怡' },
    ],
  },
  {
    quizId: '383',
    question: '第57期本因坊戦の挑戦者は？',
    options: [
      { optionId: '0', text: '緒方' },
      { optionId: '1', text: '芹澤' },
      { optionId: '2', text: '倉田' },
      { optionId: '3', text: '畑中' },
      { optionId: '4', text: '塔矢アキラ' },
    ],
  },
  {
    quizId: '384',
    question:
      '塔矢行洋の中国リーグの取材のため、NHKの囲碁将棋ジャーナルと一緒に深圳へ行ったのは？',
    options: [
      { optionId: '0', text: '吉川' },
      { optionId: '1', text: '相川' },
      { optionId: '2', text: '戸刈' },
      { optionId: '3', text: '土井' },
      { optionId: '4', text: '古瀬村' },
    ],
  },
  {
    quizId: '385',
    question: '徐彰元が所属しているチームは？',
    options: [
      { optionId: '0', text: '深圳チーム' },
      { optionId: '1', text: '北京チーム' },
      { optionId: '2', text: '上海チーム' },
      { optionId: '3', text: '香港チーム' },
      { optionId: '4', text: '広州チーム' },
    ],
  },
  {
    quizId: '386',
    question:
      '次の内、和谷の部屋でしている研究会で行うリーグ戦に参加していないのは？',
    options: [
      { optionId: '0', text: '小宮' },
      { optionId: '1', text: '越智' },
      { optionId: '2', text: '中山' },
      { optionId: '3', text: '冴木' },
      { optionId: '4', text: '本田' },
    ],
  },
  {
    quizId: '387',
    question:
      '古瀬村が取材の為に韓国棋院にアポを取った時、電話を受けた韓国棋院の通訳者は？',
    options: [
      { optionId: '0', text: '金' },
      { optionId: '1', text: '朴' },
      { optionId: '2', text: '愈' },
      { optionId: '3', text: '李' },
      { optionId: '4', text: '張' },
    ],
  },
  {
    quizId: '388',
    question:
      '北斗杯編より問題です。\n北斗杯に向けての練習手合で塔矢家へ行く時、ヒカルと社が遅くなった理由は？',
    options: [
      { optionId: '0', text: '曲がり道を1本間違えて迷った' },
      { optionId: '1', text: '地図をなくして迷った' },
      { optionId: '2', text: '寝過ごして駅を通り越した' },
      { optionId: '3', text: '社が逆方向の電車に乗ってしまった' },
      { optionId: '4', text: '時間を勘違いしていた' },
    ],
  },
  {
    quizId: '389',
    question:
      '北斗杯編より問題です。\n塔矢家での北斗杯に向けての練習手合で行った超早碁の情報として間違っているものは？',
    options: [
      { optionId: '0', text: '最後の対局での勝利者はヒカル' },
      { optionId: '1', text: '一手10秒' },
      { optionId: '2', text: '負けた者が交代' },
      { optionId: '3', text: '連戦するものが白番' },
      { optionId: '4', text: '最初の対局は社と塔矢' },
    ],
  },
  {
    quizId: '390',
    question:
      '第173局 「大将は塔矢」の扉絵で寝ている社に塔矢アキラが投げているものは？',
    options: [
      { optionId: '0', text: 'やかん' },
      { optionId: '1', text: '扇子' },
      { optionId: '2', text: '詰碁集' },
      { optionId: '3', text: '碁石' },
      { optionId: '4', text: '碁笥' },
    ],
  },
  {
    quizId: '391',
    question:
      '北斗杯編より問題です。\n北斗杯に向けての練習手合の時、塔矢家に倉田が来てから、少し早い昼食に取った出前は？',
    options: [
      { optionId: '0', text: '寿司' },
      { optionId: '1', text: 'そば' },
      { optionId: '2', text: '天丼' },
      { optionId: '3', text: 'ピザ' },
      { optionId: '4', text: 'ラーメン' },
    ],
  },
  {
    quizId: '392',
    question: '社清春の出身は？',
    options: [
      { optionId: '0', text: '関東' },
      { optionId: '1', text: '関西' },
      { optionId: '2', text: '九州' },
      { optionId: '3', text: '東北' },
      { optionId: '4', text: '四国' },
    ],
  },
  {
    quizId: '393',
    question:
      '北斗杯編より問題です。\n楽平が北斗杯で日本に付いていこうと、もぐりこんでいたのは誰のバッグ？',
    options: [
      { optionId: '0', text: '楊海' },
      { optionId: '1', text: '陸力' },
      { optionId: '2', text: '王世振' },
      { optionId: '3', text: '趙石' },
      { optionId: '4', text: '陳学明' },
    ],
  },
  {
    quizId: '394',
    question: '北斗杯編より問題です。\n塔矢アキラが勉強中の言葉は？',
    options: [
      { optionId: '0', text: '北京語' },
      { optionId: '1', text: '広東語' },
      { optionId: '2', text: '台湾語' },
      { optionId: '3', text: '上海語' },
      { optionId: '4', text: '湖南語' },
    ],
  },
  {
    quizId: '395',
    question:
      '北斗杯編より問題です。\nレセプションで司会進行を務めていたのは誰？',
    options: [
      { optionId: '0', text: '佐野智子' },
      { optionId: '1', text: '矢作陽子' },
      { optionId: '2', text: '小倉美咲' },
      { optionId: '3', text: '白石琴美' },
      { optionId: '4', text: '八武崎綾' },
    ],
  },
  {
    quizId: '396',
    question:
      '北斗杯編より問題です。\n中国の代表として組み合わせ抽選をひいたのは？',
    options: [
      { optionId: '0', text: '陸力' },
      { optionId: '1', text: '楊海' },
      { optionId: '2', text: '王世振' },
      { optionId: '3', text: '趙石' },
      { optionId: '4', text: '陳学明' },
    ],
  },
  {
    quizId: '397',
    question: '北斗杯編より問題です。\n北斗杯で大盤解説をしていたプロ棋士は？',
    options: [
      { optionId: '0', text: '渡辺八段' },
      { optionId: '1', text: '松永六段' },
      { optionId: '2', text: '上前津七段' },
      { optionId: '3', text: '白川七段' },
      { optionId: '4', text: '芦原四段' },
    ],
  },
  {
    quizId: '398',
    question:
      '北斗杯編より問題です。\n北斗杯の1戦目の時、検討室で安太善の謝罪を古瀬村に通訳した韓国の随行員は？',
    options: [
      { optionId: '0', text: '相勲' },
      { optionId: '1', text: '在旭' },
      { optionId: '2', text: '日載' },
      { optionId: '3', text: '昌炅' },
      { optionId: '4', text: '貞元' },
    ],
  },
  {
    quizId: '399',
    question: 'ヒカルの母の名前は？',
    options: [
      { optionId: '0', text: '美津子' },
      { optionId: '1', text: '琴美' },
      { optionId: '2', text: '洋子' },
      { optionId: '3', text: '直美' },
      { optionId: '4', text: '麻里江' },
    ],
  },
  {
    quizId: '400',
    question: '大会の際、葉瀬中囲碁部女子で三将を務めていたのは？',
    options: [
      { optionId: '0', text: '津田久美子' },
      { optionId: '1', text: '藤崎あかり' },
      { optionId: '2', text: '金子正子' },
      { optionId: '3', text: '青井奈緒' },
      { optionId: '4', text: '西尾由美' },
    ],
  },
  {
    quizId: '401',
    question:
      '北斗杯編より問題です。\n日本と中国の大将戦、塔矢アキラと陸力の対局結果は？',
    options: [
      { optionId: '0', text: '塔矢の2目半勝ち' },
      { optionId: '1', text: '塔矢の1目半勝ち' },
      { optionId: '2', text: '塔矢の中押し勝ち' },
      { optionId: '3', text: '塔矢の1目半負け' },
      { optionId: '4', text: '塔矢の3目半負け' },
    ],
  },
  {
    quizId: '402',
    question:
      '北斗杯編より問題です。\n日本と中国の副将戦、進藤ヒカルと王世振の対局結果は？',
    options: [
      { optionId: '0', text: 'ヒカルの1目半負け' },
      { optionId: '1', text: 'ヒカルの3目半負け' },
      { optionId: '2', text: 'ヒカルの2目半勝ち' },
      { optionId: '3', text: 'ヒカルの1目半勝ち' },
      { optionId: '4', text: 'ヒカルの半目負け' },
    ],
  },
  {
    quizId: '403',
    question:
      '北斗杯編より問題です。\n日本と中国の三将戦、社清春と趙石の対局結果は？',
    options: [
      { optionId: '0', text: '社の3目半負け' },
      { optionId: '1', text: '社の1目半負け' },
      { optionId: '2', text: '社の2目半勝ち' },
      { optionId: '3', text: '社の1目半勝ち' },
      { optionId: '4', text: '社の半目負け' },
    ],
  },
  {
    quizId: '404',
    question:
      '北斗杯編より問題です。\n次の内、北斗杯2日目に会場に訪れていないのは？',
    options: [
      { optionId: '0', text: '三谷祐輝' },
      { optionId: '1', text: '吉川八段' },
      { optionId: '2', text: '筒井公宏' },
      { optionId: '3', text: '堂本' },
      { optionId: '4', text: '本田敏則' },
    ],
  },
  {
    quizId: '405',
    question:
      '北斗杯編より問題です。\n日本と韓国の副将戦、塔矢アキラと林日煥の対局結果は？',
    options: [
      { optionId: '0', text: '塔矢の中押し勝ち' },
      { optionId: '1', text: '塔矢の2目半勝ち' },
      { optionId: '2', text: '塔矢の1目半勝ち' },
      { optionId: '3', text: '塔矢の1目半負け' },
      { optionId: '4', text: '塔矢の3目半負け' },
    ],
  },
  {
    quizId: '406',
    question:
      '北斗杯編より問題です。\n日本と韓国の三将戦、社清春と洪秀英の対局結果は？',
    options: [
      { optionId: '0', text: '社の3目半負け' },
      { optionId: '1', text: '社の1目半負け' },
      { optionId: '2', text: '社の2目半勝ち' },
      { optionId: '3', text: '社の1目半勝ち' },
      { optionId: '4', text: '社の半目負け' },
    ],
  },
  {
    quizId: '407',
    question:
      '北斗杯編、楊海の台詞より問題です。\n「食いモンは○○が一番と思ってるヤツですよ オレは」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '四川' },
      { optionId: '1', text: '北京' },
      { optionId: '2', text: '広東' },
      { optionId: '3', text: '上海' },
      { optionId: '4', text: '和食' },
    ],
  },
  {
    quizId: '408',
    question:
      '第1局のタイトル 『棋聖降臨』になる前の、担当にボツくらったタイトル案は？',
    options: [
      { optionId: '0', text: '藤原佐為' },
      { optionId: '1', text: '神様憑依' },
      { optionId: '2', text: 'ヒカルの一手' },
      { optionId: '3', text: 'ヒカルの一歩' },
      { optionId: '4', text: '最強の本因坊' },
    ],
  },
  {
    quizId: '409',
    question:
      '北斗杯編より問題です。\n日本と韓国の大将戦、進藤ヒカルと高永夏の対局結果は？',
    options: [
      { optionId: '0', text: 'ヒカルの半目負け' },
      { optionId: '1', text: 'ヒカルの1目半負け' },
      { optionId: '2', text: 'ヒカルの3目半負け' },
      { optionId: '3', text: 'ヒカルの2目半勝ち' },
      { optionId: '4', text: 'ヒカルの1目半勝ち' },
    ],
  },
  {
    quizId: '410',
    question: '北斗杯の情報として間違っているものは？',
    options: [
      { optionId: '0', text: '初戦の組み合わせは『中国 VS 韓国』' },
      { optionId: '1', text: '三位まで賞金が出る' },
      { optionId: '2', text: '韓国は中国にストレート勝ち' },
      { optionId: '3', text: '最下位は日本' },
      { optionId: '4', text: '来年も北斗杯が開かれる' },
    ],
  },
  {
    quizId: '411',
    question:
      '北斗杯編より問題です。\n何故碁を打つのか問われて、ヒカルは何と答えた？',
    options: [
      { optionId: '0', text: '遠い過去と遠い未来をつなげるため' },
      { optionId: '1', text: '神の一手を極めるため' },
      { optionId: '2', text: '秀策に会うため' },
      { optionId: '3', text: '碁の神様に会うため' },
      { optionId: '4', text: '無限の可能性があるから' },
    ],
  },
  {
    quizId: '412',
    question:
      'ヒカルの碁の最終回後に小畑健にもらったキャラを描いてもらったスケッチブックの中で、ほったゆみが1番カッコイイと思った絵は？',
    options: [
      { optionId: '0', text: '緒方精次' },
      { optionId: '1', text: '高永夏' },
      { optionId: '2', text: '伊角慎一郎' },
      { optionId: '3', text: '塔矢アキラ' },
      { optionId: '4', text: '塔矢行洋' },
    ],
  },
  {
    quizId: '413',
    question:
      '〈番外編〉②庄司君っ！ 岡君っ！より問題です。\n第十一回若獅子戦出場時の岡の院生順位は？',
    options: [
      { optionId: '0', text: '14位' },
      { optionId: '1', text: '8位' },
      { optionId: '2', text: '10位' },
      { optionId: '3', text: '12位' },
      { optionId: '4', text: '16位' },
    ],
  },
  {
    quizId: '414',
    question: '第十一回若獅子戦より問題です。\n本田の一回戦の対局相手は？',
    options: [
      { optionId: '0', text: '奈瀬明日美' },
      { optionId: '1', text: '小宮英二' },
      { optionId: '2', text: '福井雄太' },
      { optionId: '3', text: '足立俊輝' },
      { optionId: '4', text: '野崎正吾' },
    ],
  },
  {
    quizId: '415',
    question:
      '第十一回若獅子戦より問題です。\n塔矢アキラの一回戦の対局相手は？',
    options: [
      { optionId: '0', text: '庄司' },
      { optionId: '1', text: '岡' },
      { optionId: '2', text: '小宮' },
      { optionId: '3', text: '奈瀬' },
      { optionId: '4', text: '野崎' },
    ],
  },
  {
    quizId: '416',
    question:
      '〈番外編〉②庄司君っ！ 岡君っ！より問題です。\n岡と庄司は何年生？',
    options: [
      { optionId: '0', text: '小学5年生' },
      { optionId: '1', text: '小学3年生' },
      { optionId: '2', text: '小学4年生' },
      { optionId: '3', text: '小学6年生' },
      { optionId: '4', text: '中学1年生' },
    ],
  },
  {
    quizId: '417',
    question: '第十一回若獅子戦より問題です。\n真柴充の一回戦の対局相手は？',
    options: [
      { optionId: '0', text: '野崎正吾' },
      { optionId: '1', text: '奈瀬明日美' },
      { optionId: '2', text: '小宮英二' },
      { optionId: '3', text: '福井雄太' },
      { optionId: '4', text: '足立俊輝' },
    ],
  },
];
